import { IIconProps, Icon } from "native-base";
import React from "react";
import { Circle, Ellipse, Path, Rect } from "react-native-svg";

interface Props extends Omit<IIconProps, "color"> {
  color?: string;
  activeColor?: string;
}

const ArrowDownIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M19 8.5L12 15.5L5 8.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const CloseSquareIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9.17188 14.83L14.8319 9.17004"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.8319 14.83L9.17188 9.17004"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const ArrowRightIcon = ({ color = "#FFFFFF", ...props }: any) => {
  return (
    <svg viewBox="0 0 24 24" {...props} color="transparent">
      <path
        d="M8.5 5L15.5 12L8.5 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fillOpacity={0}
      />
    </svg>
  );
};

const ArrowUpIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M5 15.5L12 8.5L19 15.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const ArrowLeftIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M15.5 19L8.5 12L15.5 5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const NotificationIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M6.44784 8.96942C6.76219 6.14032 9.15349 4 12 4V4C14.8465 4 17.2378 6.14032 17.5522 8.96942L17.804 11.2356C17.8072 11.2645 17.8088 11.279 17.8104 11.2933C17.9394 12.4169 18.3051 13.5005 18.8836 14.4725C18.8909 14.4849 18.8984 14.4973 18.9133 14.5222L19.4914 15.4856C20.0159 16.3599 20.2782 16.797 20.2216 17.1559C20.1839 17.3946 20.061 17.6117 19.8757 17.7668C19.5971 18 19.0873 18 18.0678 18H5.93223C4.91268 18 4.40291 18 4.12434 17.7668C3.93897 17.6117 3.81609 17.3946 3.77841 17.1559C3.72179 16.797 3.98407 16.3599 4.50862 15.4856L5.08665 14.5222C5.10161 14.4973 5.10909 14.4849 5.11644 14.4725C5.69488 13.5005 6.06064 12.4169 6.18959 11.2933C6.19123 11.279 6.19283 11.2645 6.19604 11.2356L6.44784 8.96942Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M9.10222 18.4059C9.27315 19.1501 9.64978 19.8077 10.1737 20.2767C10.6976 20.7458 11.3396 21 12 21C12.6604 21 13.3024 20.7458 13.8263 20.2767C14.3502 19.8077 14.7269 19.1501 14.8978 18.4059"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const MusicTwoIcon = ({ color = "#FFFFFF", strokeWidth, ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9 16H6.25245C6.018 16 5.90078 16 5.80205 16.0098C4.85403 16.1041 4.10411 16.854 4.00982 17.802C4 17.9008 4 18.018 4 18.2525V18.2525C4 18.5322 4 18.6721 4.01244 18.7831C4.13321 19.8608 5.0909 20.646 6.17139 20.553C6.28269 20.5435 6.41986 20.516 6.69419 20.4612L6.99029 20.4019C7.37076 20.3258 7.56099 20.2878 7.7215 20.2257C8.3765 19.9724 8.85063 19.394 8.9706 18.7021C9 18.5325 9 18.3385 9 17.9505V9.27922C9 7.70946 9 6.92459 9.45332 6.37163C9.90663 5.81867 10.6763 5.66475 12.2155 5.35689L14.2155 4.95689C16.4291 4.51417 17.536 4.29281 18.268 4.89292C19 5.49304 19 6.62176 19 8.87922V9M19 14V15.9505C19 16.3385 19 16.5325 18.9706 16.7021C18.8506 17.394 18.3765 17.9724 17.7215 18.2257C17.561 18.2878 17.3708 18.3258 16.9903 18.4019L16.6942 18.4612C16.4199 18.516 16.2827 18.5435 16.1714 18.553C15.0909 18.646 14.1332 17.8608 14.0124 16.7831C14 16.6721 14 16.5322 14 16.2525V16.2525C14 16.018 14 15.9008 14.0098 15.802C14.1041 14.854 14.854 14.1041 15.802 14.0098C15.9008 14 16.018 14 16.2525 14H19ZM19 14V9M19 9L9 11"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
      />
    </Icon>
  );
};

const MicroIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="9"
        y="3"
        width="6"
        height="11"
        rx="3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <Path
        d="M18 11C18 12.5913 17.3679 14.1174 16.2426 15.2426C15.1174 16.3679 13.5913 17 12 17C10.4087 17 8.88258 16.3679 7.75736 15.2426C6.63214 14.1174 6 12.5913 6 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 21V19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const VideoIcon = ({ color = "#FFFFFF", strokeWidth, ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.8163 15.62C15.8163 17.613 14.4583 19.021 12.2863 19.021H6.06929C3.89929 19.021 2.55029 17.613 2.55029 15.62V8.66C2.55029 6.668 3.89929 5.25 6.08029 5.25H12.2863C14.4583 5.25 15.8163 6.668 15.8163 8.66V15.62Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.8164 11.2766L19.9134 7.9226C20.5634 7.3876 21.5504 7.8526 21.5504 8.6996V15.5716C21.5504 16.4196 20.5634 16.8826 19.9134 16.3486L15.8164 12.9946"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const FolderIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9757 14.9567C19.9757 18.13 18.1084 20 14.9396 20H8.04422C4.86733 20 3 18.13 3 14.9567V8.04333C3 4.87 4.16405 3 7.33286 3H9.10319C9.73929 3 10.3383 3.29992 10.7199 3.80952L11.5283 4.88619C11.9108 5.3948 12.5092 5.69445 13.145 5.69571H15.651C18.8279 5.69571 20 7.31476 20 10.5529L19.9757 14.9567Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7 15H16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const FolderAddIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M11.5283 20H8.04422C4.86733 20 3 18.13 3 14.9567V8.04333C3 4.87 4.16405 3 7.33286 3H9.10319C9.73929 3 10.3383 3.29992 10.7199 3.80952L11.5283 4.88619C11.9108 5.3948 12.5092 5.69445 13.145 5.69571H15.651C18.8279 5.69571 20 7.31476 20 10.5529"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18 13L18 21M22 17L14 17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const FolderRemoveIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M11.5283 20H8.04422C4.86733 20 3 18.13 3 14.9567V8.04333C3 4.87 4.16405 3 7.33286 3H9.10319C9.73929 3 10.3383 3.29992 10.7199 3.80952L11.5283 4.88619C11.9108 5.3948 12.5092 5.69445 13.145 5.69571H15.651C18.8279 5.69571 20 7.31476 20 10.5529"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14 17.6667L17.0522 20.0406C17.2629 20.2045 17.5651 20.174 17.7388 19.9714L22 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const SearchIcon = ({ color = "#FFFFFF", strokeWidth, ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.9999 21.0004L16.6499 16.6504"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const MusicIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M6 21C7.65685 21 9 19.6569 9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9 18V5L21 3V16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16C15 17.6569 16.3431 19 18 19Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const CopyIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M15 5.9V5.9C15 4.11148 15 3.21721 14.4686 2.6424C14.4331 2.60394 14.3961 2.5669 14.3576 2.53136C13.7828 2 12.8885 2 11.1 2H6C4.11438 2 3.17157 2 2.58579 2.58579C2 3.17157 2 4.11438 2 6V11.1C2 12.8885 2 13.7828 2.53136 14.3576C2.5669 14.3961 2.60394 14.4331 2.6424 14.4686C3.21721 15 4.11148 15 5.9 15V15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
      <Rect
        x="10"
        y="10"
        width="12"
        height="12"
        rx="2"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="bevel"
      />
    </Icon>
  );
};

const EyeClosedIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9.76045 14.3677C9.18545 13.7937 8.83545 13.0137 8.83545 12.1387C8.83545 10.3857 10.2474 8.97266 11.9994 8.97266C12.8664 8.97266 13.6644 9.32366 14.2294 9.89766"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.1049 12.6992C14.8729 13.9892 13.8569 15.0072 12.5679 15.2412"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6.65451 17.473C5.06751 16.227 3.72351 14.407 2.74951 12.138C3.73351 9.85896 5.08651 8.02896 6.68351 6.77296C8.27051 5.51696 10.1015 4.83496 11.9995 4.83496C13.9085 4.83496 15.7385 5.52696 17.3355 6.79196"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.4473 8.99121C20.1353 9.90521 20.7403 10.9602 21.2493 12.1372C19.2823 16.6942 15.8063 19.4392 11.9993 19.4392C11.1363 19.4392 10.2853 19.2992 9.46729 19.0262"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.8868 4.25L4.11279 20.024"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const EyeOpenedIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1614 12.0536C15.1614 13.7996 13.7454 15.2146 11.9994 15.2146C10.2534 15.2146 8.83838 13.7996 8.83838 12.0536C8.83838 10.3066 10.2534 8.8916 11.9994 8.8916C13.7454 8.8916 15.1614 10.3066 15.1614 12.0536Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.998 19.355C15.806 19.355 19.289 16.617 21.25 12.053C19.289 7.48898 15.806 4.75098 11.998 4.75098H12.002C8.194 4.75098 4.711 7.48898 2.75 12.053C4.711 16.617 8.194 19.355 12.002 19.355H11.998Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const MoreVerticalIcon = ({ color = "#FFFFFF", ...props }: any) => {
  return (
    <svg viewBox="0 0 24 24" {...props} color="transparent">
      <path
        d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const AirPlayIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M5 17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V15C22 15.5304 21.7893 16.0391 21.4142 16.4142C21.0391 16.7893 20.5304 17 20 17H19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 15L17 21H7L12 15Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const ShareIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.58984 13.5098L15.4198 17.4898"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.4098 6.50977L8.58984 10.4898"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const DownloadIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M4 17V20.2C4 20.4122 4.21071 20.6157 4.58579 20.7657C4.96086 20.9157 5.46957 21 6 21H18C18.5304 21 19.0391 20.9157 19.4142 20.7657C19.7893 20.6157 20 20.4122 20 20.2V17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 12L12 16L8 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 3V16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const DownloadedIcon = ({
  color = "#FFFFFF",
  activeColor,
  ...props
}: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M4 17V20.2C4 20.4122 4.21071 20.6157 4.58579 20.7657C4.96086 20.9157 5.46957 21 6 21H12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 12L12 16L8 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 3V16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 19C24 21.7614 21.7614 24 19 24C16.2386 24 14 21.7614 14 19C14 16.2386 16.2386 14 19 14C21.7614 14 24 16.2386 24 19ZM21.5694 18.1546C21.839 17.8401 21.8026 17.3666 21.4881 17.0971C21.1736 16.8275 20.7001 16.8639 20.4306 17.1784L18.6102 19.3021L17.4605 18.4078C17.1335 18.1535 16.6623 18.2124 16.408 18.5394C16.1537 18.8663 16.2126 19.3375 16.5395 19.5919L17.8775 20.6325C18.4042 21.0421 19.1598 20.9659 19.594 20.4593L21.5694 18.1546Z"
        fill={activeColor || color}
      />
    </Icon>
  );
};

const CheckIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M4 12.3333L10.4808 17.374C10.6915 17.5378 10.9937 17.5073 11.1674 17.3047L20 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const ShuffleIcon = ({ color = "#FFFFFF", ...props }: any) => {
  return (
    <svg viewBox="0 0 24 24" {...props} color="transparent">
      <path
        d="M3 7H4.77985C6.93172 7 8.00766 7 8.87921 7.45631C9.25172 7.65134 9.59114 7.90388 9.88499 8.20464C10.5725 8.90832 10.8817 9.93888 11.5 12V12C12.1183 14.0611 12.4275 15.0917 13.115 15.7954C13.4089 16.0961 13.7483 16.3487 14.1208 16.5437C14.9923 17 16.0683 17 18.2202 17H21M21 17L18 14M21 17L18 20"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5303 3.46967C18.2374 3.17678 17.7626 3.17678 17.4697 3.46967C17.1768 3.76256 17.1768 4.23744 17.4697 4.53033L19.1893 6.25H18.2202H18.1855C17.1389 6.24999 16.3044 6.24999 15.6245 6.30994C14.9243 6.37167 14.3292 6.50063 13.7729 6.79187C13.3306 7.02347 12.9275 7.32336 12.5786 7.68051C12.5784 7.68069 12.5782 7.68088 12.578 7.68106C12.7586 8.00458 12.9084 8.33563 13.0406 8.66737C13.1155 8.85509 13.1887 9.05388 13.2613 9.26249C13.3845 9.04223 13.5108 8.87277 13.6515 8.72877C13.8902 8.48441 14.166 8.27921 14.4687 8.12075C14.7839 7.95569 15.1625 7.85649 15.7562 7.80414C16.3626 7.75067 17.1311 7.75 18.2202 7.75H19.1893L17.4697 9.46967C17.1768 9.76256 17.1768 10.2374 17.4697 10.5303C17.7626 10.8232 18.2374 10.8232 18.5303 10.5303L21.5303 7.53033C21.8232 7.23744 21.8232 6.76256 21.5303 6.46967L18.5303 3.46967ZM10.422 16.3189C10.2414 15.9954 10.0916 15.6644 9.95935 15.3326C9.8845 15.1449 9.81126 14.9461 9.73869 14.7375C9.61554 14.9578 9.48922 15.1272 9.34853 15.2712C9.10978 15.5156 8.834 15.7208 8.53134 15.8792C8.21606 16.0443 7.83746 16.1435 7.24378 16.1959C6.63738 16.2493 5.86891 16.25 4.77985 16.25H3C2.58579 16.25 2.25 16.5858 2.25 17C2.25 17.4142 2.58579 17.75 3 17.75H4.77985H4.81454C5.86108 17.75 6.69559 17.75 7.37552 17.6901C8.07567 17.6283 8.67081 17.4994 9.22709 17.2081C9.66944 16.9765 10.0725 16.6766 10.4214 16.3195C10.4216 16.3193 10.4218 16.3191 10.422 16.3189Z"
        fill={color}
      />
    </svg>
  );
};

const SortIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M3 6.46667L7 3M7 3L11 6.46667M7 3L7 16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M13 17.5333L17 21M17 21L21 17.5333M17 21L17 8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const RepeatIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M7 4L4 7M4 7L7 10M4 7L18 7C19.1046 7 20 7.89543 20 9L20 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17 14L20 17M20 17L17 20M20 17L6 17C4.89543 17 4 16.1046 4 15L4 14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const RepeatOneTimeIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M7 20L4 17M4 17L7 14M4 17L18 17C19.1046 17 20 16.1046 20 15L20 14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12.5 10L15.5 7M15.5 7L12.5 4M15.5 7L6 7C4.89543 7 4 7.89543 4 9L4 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M18.2213 12.0004C17.7813 12.0004 17.5613 11.787 17.5613 11.3604C17.5613 10.9404 17.7813 10.7304 18.2213 10.7304H19.2313V6.67035L18.5013 7.11035C18.308 7.22369 18.1347 7.25368 17.9813 7.20035C17.828 7.14702 17.7113 7.04702 17.6313 6.90035C17.5513 6.75369 17.528 6.59702 17.5613 6.43035C17.5947 6.25702 17.7047 6.11035 17.8913 5.99035L19.2813 5.15035C19.4213 5.06369 19.5613 4.99369 19.7013 4.94035C19.848 4.88702 19.9913 4.86035 20.1313 4.86035C20.3313 4.86035 20.488 4.91369 20.6013 5.02035C20.7213 5.12702 20.7813 5.28369 20.7813 5.49035V10.7304H21.6913C22.1247 10.7304 22.3413 10.9404 22.3413 11.3604C22.3413 11.787 22.1247 12.0004 21.6913 12.0004H18.2213Z"
        fill={color}
      />
    </Icon>
  );
};

const LyricsIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M2 7H12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M2 12H10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M2 17H8"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M17.3333 13.5556H14.0804C12.8229 13.5556 11.7568 14.4802 11.5789 15.725V15.725C11.3433 17.3744 12.7405 18.7963 14.3938 18.5897L14.8275 18.5355C16.259 18.3565 17.3333 17.1396 17.3333 15.6969V9.16629C17.3333 7.54794 17.3333 6.73877 17.8073 6.17928C18.2812 5.61979 19.0794 5.48676 20.6757 5.22071L21.6991 5.05015C21.8349 5.02751 21.9028 5.01619 21.9394 5.05588C21.9761 5.09557 21.9594 5.16236 21.926 5.29593L21.2529 7.98832C21.238 8.048 21.2305 8.07784 21.2095 8.09784C21.1886 8.11784 21.1584 8.12387 21.0981 8.13593L17.3333 8.88889"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const ArtistMusicIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="8.79565"
        cy="7"
        r="4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M12.4481 14.0192C11.4003 13.2151 10.1164 12.7793 8.79556 12.7793C7.47475 12.7793 6.19085 13.2151 5.14299 14.0192C4.09512 14.8232 3.34185 15.9506 3 17.2264"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M17.129 16.3333H14.3407C13.2629 16.3333 12.3491 17.1259 12.1967 18.1929V18.1929C11.9947 19.6066 13.1923 20.8254 14.6094 20.6483L14.9811 20.6018C16.2082 20.4484 17.129 19.4054 17.129 18.1688V13.0552C17.129 11.4368 17.129 10.6277 17.6029 10.0682C18.0769 9.50868 18.8751 9.37565 20.4714 9.1096L20.8281 9.05015C20.9639 9.02751 21.0318 9.01619 21.0685 9.05588C21.1051 9.09557 21.0884 9.16236 21.055 9.29593L20.493 11.5439C20.4781 11.6036 20.4706 11.6334 20.4497 11.6534C20.4287 11.6734 20.3985 11.6794 20.3382 11.6915L17.129 12.3333"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const ArtistVideoIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="8.79565"
        cy="7"
        r="4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M12.4481 14.0192C11.4003 13.2151 10.1164 12.7793 8.79556 12.7793C7.47475 12.7793 6.19085 13.2151 5.14299 14.0192C4.09512 14.8232 3.34185 15.9506 3 17.2264"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M15.7367 21.1317L16.0721 21.8025L15.7367 21.1317ZM16.0721 14.1975L20.5466 16.4348L19.8757 17.7764L15.4012 15.5391L16.0721 14.1975ZM20.5466 19.5652L16.0721 21.8025L15.4012 20.4609L19.8757 18.2236L20.5466 19.5652ZM14.75 15.9416V20.0584H13.25V15.9416H14.75ZM16.0721 21.8025C14.7755 22.4508 13.25 21.508 13.25 20.0584H14.75C14.75 20.3929 15.102 20.6105 15.4012 20.4609L16.0721 21.8025ZM20.5466 16.4348C21.8364 17.0797 21.8364 18.9203 20.5466 19.5652L19.8757 18.2236C20.06 18.1315 20.06 17.8685 19.8757 17.7764L20.5466 16.4348ZM15.4012 15.5391C15.102 15.3895 14.75 15.6071 14.75 15.9416H13.25C13.25 14.492 14.7755 13.5492 16.0721 14.1975L15.4012 15.5391Z"
        fill={color}
      />
    </Icon>
  );
};

const ArtistDontRecommendIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="8.79565"
        cy="7"
        r="4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M12.4481 14.0192C11.4003 13.2151 10.1164 12.7793 8.79556 12.7793C7.47475 12.7793 6.19085 13.2151 5.14299 14.0192C4.09512 14.8232 3.34185 15.9506 3 17.2264"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M20.6667 19.6666L15.3333 14.3333M22 17C22 19.2091 20.2091 21 18 21C15.7909 21 14 19.2091 14 17C14 14.7909 15.7909 13 18 13C20.2091 13 22 14.7909 22 17Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const ArtistAllowedRecommendIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="8.79565"
        cy="7"
        r="4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M12.4481 14.0192C11.4003 13.2151 10.1164 12.7793 8.79556 12.7793C7.47475 12.7793 6.19085 13.2151 5.14299 14.0192C4.09512 14.8232 3.34185 15.9506 3 17.2264"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M14 17.6667L17.0522 20.0406C17.2629 20.2045 17.5651 20.174 17.7388 19.9714L22 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const PlaylistIcon = ({ color = "#FFFFFF", strokeWidth, ...props }: Props) => {
  return (
    <Icon
      viewBox="0 0 60 60"
      {...props}
      strokeWidth={strokeWidth}
      color="transparent"
    >
      <Path
        d="M33 35H22.4384C19.1303 35 17.4762 35 16.3484 35.9782C15.2205 36.9564 14.9866 38.5938 14.5188 41.8686L14.4812 42.1313C13.801 46.893 13.4609 49.2739 14.8473 50.6848C16.2337 52.0958 18.6202 51.7975 23.3931 51.2009L25.9923 50.876C29.329 50.4589 30.9974 50.2503 31.9987 49.1161C33 47.9818 33 46.3005 33 42.9377V13.3885C33 11.7702 33 10.961 33.474 10.4015C33.9479 9.84201 34.7461 9.70899 36.3424 9.44293L47.6991 7.55015C47.8349 7.52751 47.9028 7.51619 47.9395 7.55588C47.9761 7.59557 47.9594 7.66236 47.926 7.79593L45.5307 17.3772C45.5158 17.4369 45.5083 17.4667 45.4873 17.4867C45.4664 17.5067 45.4362 17.5128 45.3759 17.5248L33 20"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
      />
    </Icon>
  );
};
const PlaylistOldIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 16 20" {...props} color="transparent">
      <Path
        d="M9 12H4.81763C3.20089 12 1.83017 13.1888 1.60153 14.7893V14.7893C1.29858 16.9099 3.09499 18.7381 5.22059 18.4724L5.77821 18.4027C7.61878 18.1727 9 16.608 9 14.7531V5.38851C9 3.77017 9 2.961 9.47396 2.4015C9.94792 1.84201 10.7461 1.70899 12.3424 1.44293L14.6991 1.05015C14.8349 1.02751 14.9028 1.01619 14.9395 1.05588C14.9761 1.09557 14.9594 1.16236 14.926 1.29593L14.0307 4.87721C14.0158 4.93689 14.0083 4.96672 13.9873 4.98673C13.9664 5.00673 13.9362 5.01276 13.8759 5.02482L9 6"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const AddToPlaylistIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M10 14H5.81763C4.20089 14 2.83017 15.1888 2.60153 16.7893V16.7893C2.29858 18.9099 4.09499 20.7381 6.22059 20.4724L6.77821 20.4027C8.61878 20.1727 10 18.608 10 16.7531V7.38851C10 5.77017 10 4.961 10.474 4.4015C10.9479 3.84201 11.7461 3.70899 13.3424 3.44293L15.6991 3.05015C15.8349 3.02751 15.9028 3.01619 15.9395 3.05588C15.9761 3.09557 15.9594 3.16236 15.926 3.29593L15.0307 6.87721C15.0158 6.93689 15.0083 6.96672 14.9873 6.98673C14.9664 7.00673 14.9362 7.01276 14.8759 7.02482L10 8"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M18 13L18 21M22 17L14 17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const DontRecommendIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M10 14H5.81763C4.20089 14 2.83017 15.1888 2.60153 16.7893V16.7893C2.29858 18.9099 4.09499 20.7381 6.22059 20.4724L6.77821 20.4027C8.61878 20.1727 10 18.608 10 16.7531V7.38851C10 5.77017 10 4.961 10.474 4.4015C10.9479 3.84201 11.7461 3.70899 13.3424 3.44293L15.6991 3.05015C15.8349 3.02751 15.9028 3.01619 15.9395 3.05588C15.9761 3.09557 15.9594 3.16236 15.926 3.29593L15.0307 6.87721C15.0158 6.93689 15.0083 6.96672 14.9873 6.98673C14.9664 7.00673 14.9362 7.01276 14.8759 7.02482L10 8"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M20.6667 19.6666L15.3333 14.3333M22 17C22 19.2091 20.2091 21 18 21C15.7909 21 14 19.2091 14 17C14 14.7909 15.7909 13 18 13C20.2091 13 22 14.7909 22 17Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const AllowedRecommendIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M10 14H5.81763C4.20089 14 2.83017 15.1888 2.60153 16.7893V16.7893C2.29858 18.9099 4.09499 20.7381 6.22059 20.4724L6.77821 20.4027C8.61878 20.1727 10 18.608 10 16.7531V7.38851C10 5.77017 10 4.961 10.474 4.4015C10.9479 3.84201 11.7461 3.70899 13.3424 3.44293L15.6991 3.05015C15.8349 3.02751 15.9028 3.01619 15.9395 3.05588C15.9761 3.09557 15.9594 3.16236 15.926 3.29593L15.0307 6.87721C15.0158 6.93689 15.0083 6.96672 14.9873 6.98673C14.9664 7.00673 14.9362 7.01276 14.8759 7.02482L10 8"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M14 17.6667L17.0522 20.0406C17.2629 20.2045 17.5651 20.174 17.7388 19.9714L22 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const AlbumIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M10.7367 15.1317L11.0721 15.8025L10.7367 15.1317ZM11.0721 8.19751L15.5466 10.4348L14.8757 11.7764L10.4012 9.53915L11.0721 8.19751ZM15.5466 13.5652L11.0721 15.8025L10.4012 14.4609L14.8757 12.2236L15.5466 13.5652ZM9.75 9.94164V14.0584H8.25V9.94164H9.75ZM11.0721 15.8025C9.77551 16.4508 8.25 15.508 8.25 14.0584H9.75C9.75 14.3929 10.102 14.6105 10.4012 14.4609L11.0721 15.8025ZM15.5466 10.4348C16.8364 11.0797 16.8364 12.9203 15.5466 13.5652L14.8757 12.2236C15.06 12.1315 15.06 11.8685 14.8757 11.7764L15.5466 10.4348ZM10.4012 9.53915C10.102 9.38955 9.75 9.60712 9.75 9.94164H8.25C8.25 8.49205 9.77551 7.54923 11.0721 8.19751L10.4012 9.53915Z"
        fill={color}
      />
      <Circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" />
    </Icon>
  );
};

const ShowVideoIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M21.5813 6.848C21.4733 6.38753 21.2534 5.96563 20.9438 5.62491C20.6341 5.28419 20.2457 5.03673 19.8178 4.9075C18.2542 4.5 12 4.5 12 4.5C12 4.5 5.74578 4.5 4.18222 4.94631C3.75429 5.07553 3.36588 5.323 3.05623 5.66372C2.74659 6.00444 2.52666 6.42634 2.41868 6.8868C2.13253 8.58042 1.99255 10.2985 2.00052 12.0194C1.99032 13.7533 2.1303 15.4844 2.41868 17.1908C2.53773 17.637 2.76258 18.0428 3.0715 18.3692C3.38043 18.6955 3.76299 18.9313 4.18222 19.0537C5.74578 19.5 12 19.5 12 19.5C12 19.5 18.2542 19.5 19.8178 19.0537C20.2457 18.9245 20.6341 18.677 20.9438 18.3363C21.2534 17.9956 21.4733 17.5737 21.5813 17.1132C21.8653 15.4323 22.0052 13.7274 21.9995 12.0194C22.0097 10.2855 21.8697 8.55436 21.5813 6.848V6.848Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.7367 15.1317L11.0721 15.8025L10.7367 15.1317ZM11.0721 8.19751L15.5466 10.4348L14.8757 11.7764L10.4012 9.53915L11.0721 8.19751ZM15.5466 13.5652L11.0721 15.8025L10.4012 14.4609L14.8757 12.2236L15.5466 13.5652ZM9.75 9.94164V14.0584H8.25V9.94164H9.75ZM11.0721 15.8025C9.77551 16.4508 8.25 15.508 8.25 14.0584H9.75C9.75 14.3929 10.102 14.6105 10.4012 14.4609L11.0721 15.8025ZM15.5466 10.4348C16.8364 11.0797 16.8364 12.9203 15.5466 13.5652L14.8757 12.2236C15.06 12.1315 15.06 11.8685 14.8757 11.7764L15.5466 10.4348ZM10.4012 9.53915C10.102 9.38955 9.75 9.60712 9.75 9.94164H8.25C8.25 8.49205 9.77551 7.54923 11.0721 8.19751L10.4012 9.53915Z"
        fill={color}
      />
    </Icon>
  );
};

const PlaylistVideoIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M17.6651 9.72531C17.5787 9.34329 17.4027 8.99327 17.155 8.7106C16.9073 8.42793 16.5966 8.22263 16.2542 8.11542C15.0034 7.77734 10 7.77734 10 7.77734C10 7.77734 4.99662 7.77734 3.74578 8.14762C3.40343 8.25482 3.09271 8.46013 2.84499 8.7428C2.59727 9.02547 2.42133 9.37549 2.33494 9.75751C2.10602 11.1626 1.99404 12.5879 2.00042 14.0157C1.99226 15.4541 2.10424 16.8904 2.33494 18.306C2.43018 18.6762 2.61006 19.0129 2.8572 19.2836C3.10434 19.5543 3.41039 19.7499 3.74578 19.8515C4.99662 20.2218 10 20.2218 10 20.2218C10 20.2218 15.0034 20.2218 16.2542 19.8515C16.5966 19.7443 16.9073 19.539 17.155 19.2563C17.4027 18.9737 17.5787 18.6236 17.6651 18.2416C17.8922 16.8471 18.0042 15.4326 17.9996 14.0157C18.0077 12.5772 17.8958 11.141 17.6651 9.72531V9.72531Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 4.42462C7.40404 4 13.0202 4 13.0202 4C13.0202 4 18.6364 4 20.0404 4.38769C20.4247 4.51063 20.7735 4.74607 21.0515 5.07022C21.3296 5.39437 21.5271 5.79576 21.624 6.23385C21.883 7.85726 22.0087 9.50427 21.9995 11.1538C22.0047 12.7788 21.879 14.4009 21.624 16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9.57207 10.6975L13.0466 12.4348L12.3757 13.7764L8.90125 12.0391L9.57207 10.6975ZM13.0466 15.5652L9.57207 17.3025L8.90125 15.9609L12.3757 14.2236L13.0466 15.5652ZM8.25 12.4416V15.5584H6.75V12.4416H8.25ZM9.57207 17.3025C8.27551 17.9508 6.75 17.008 6.75 15.5584H8.25C8.25 15.8929 8.60204 16.1105 8.90125 15.9609L9.57207 17.3025ZM13.0466 12.4348C14.3364 13.0797 14.3364 14.9203 13.0466 15.5652L12.3757 14.2236C12.56 14.1315 12.56 13.8685 12.3757 13.7764L13.0466 12.4348ZM8.90125 12.0391C8.60204 11.8895 8.25 12.1071 8.25 12.4416H6.75C6.75 10.992 8.27551 10.0492 9.57207 10.6975L8.90125 12.0391Z"
        fill={color}
      />
    </Icon>
  );
};

const PlaylistVideoAddedIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M17.6651 9.72531C17.5787 9.34329 17.4027 8.99327 17.155 8.7106C16.9073 8.42793 16.5966 8.22263 16.2542 8.11542C15.0034 7.77734 10 7.77734 10 7.77734C10 7.77734 4.99662 7.77734 3.74578 8.14762C3.40343 8.25482 3.09271 8.46013 2.84499 8.7428C2.59727 9.02547 2.42133 9.37549 2.33494 9.75751C2.10602 11.1626 1.99404 12.5879 2.00042 14.0157C1.99226 15.4541 2.10424 16.8904 2.33494 18.306C2.43018 18.6762 2.61006 19.0129 2.8572 19.2836C3.10434 19.5543 3.41039 19.7499 3.74578 19.8515C4.99662 20.2218 10 20.2218 10 20.2218C10 20.2218 15.0034 20.2218 16.2542 19.8515C16.5966 19.7443 16.9073 19.539 17.155 19.2563C17.4027 18.9737 17.5787 18.6236 17.6651 18.2416C17.8922 16.8471 18.0042 15.4326 17.9996 14.0157C18.0077 12.5772 17.8958 11.141 17.6651 9.72531V9.72531Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 4.42462C7.40404 4 13.0202 4 13.0202 4C13.0202 4 18.6364 4 20.0404 4.38769C20.4247 4.51063 20.7735 4.74607 21.0515 5.07022C21.3296 5.39437 21.5271 5.79576 21.624 6.23385C21.883 7.85726 22.0087 9.50427 21.9995 11.1538C22.0047 12.7788 21.879 14.4009 21.624 16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 13.9997L9.05224 16.3736C9.26292 16.5375 9.56515 16.507 9.73884 16.3044L14 11.333"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const ShowPodcastIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1.5" />
      <Path
        d="M12.0001 13.654C12.9134 13.654 13.6538 12.9136 13.6538 12.0003C13.6538 11.087 12.9134 10.3467 12.0001 10.3467C11.0868 10.3467 10.3464 11.087 10.3464 12.0003C10.3464 12.9136 11.0868 13.654 12.0001 13.654Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.5058 8.4946C15.9671 8.95534 16.333 9.50248 16.5826 10.1047C16.8323 10.707 16.9608 11.3525 16.9608 12.0045C16.9608 12.6564 16.8323 13.302 16.5826 13.9043C16.333 14.5065 15.9671 15.0536 15.5058 15.5144M8.4943 15.5061C8.03304 15.0454 7.66713 14.4982 7.41747 13.896C7.16781 13.2937 7.03931 12.6482 7.03931 11.9962C7.03931 11.3443 7.16781 10.6987 7.41747 10.0965C7.66713 9.49421 8.03304 8.94707 8.4943 8.48633"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const PlayLineIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M20.0661 10.7942L8.35088 3.24558C7.35176 2.60072 6 3.30248 6 4.45942V19.5377C6 20.7136 7.35176 21.3964 8.35088 20.7515L20.0661 13.2029C20.9477 12.6529 20.9477 11.3632 20.0661 10.7942Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const FavoriteLightIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M4.45067 13.9082L11.4033 20.4395C11.6428 20.6644 11.7625 20.7769 11.9037 20.8046C11.9673 20.8171 12.0327 20.8171 12.0963 20.8046C12.2375 20.7769 12.3572 20.6644 12.5967 20.4395L19.5493 13.9082C21.5055 12.0706 21.743 9.0466 20.0978 6.92607L19.7885 6.52734C17.8203 3.99058 13.8696 4.41601 12.4867 7.31365C12.2913 7.72296 11.7087 7.72296 11.5133 7.31365C10.1304 4.41601 6.17972 3.99058 4.21154 6.52735L3.90219 6.92607C2.25695 9.0466 2.4945 12.0706 4.45067 13.9082Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const WifiOffIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M1 1L23 23"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 20H12.01"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.53003 16.1097C9.54523 15.3885 10.7597 15.001 12.005 15.001C13.2504 15.001 14.4648 15.3885 15.48 16.1097"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.72 11.0596C17.5391 11.4593 18.305 11.9599 19 12.5496"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5 12.5502C6.48208 11.311 8.26587 10.4864 10.17 10.1602"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M1.41992 9.00012C2.80709 7.77397 4.39762 6.79934 6.11992 6.12012"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10.71 5.04974C12.8524 4.87711 15.0076 5.1379 17.047 5.81656C19.0864 6.49521 20.9682 7.57782 22.58 8.99974"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const TileIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="3"
        y="3"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Rect
        x="3"
        y="14"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Rect
        x="14"
        y="3"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Rect
        x="14"
        y="14"
        width="7"
        height="7"
        rx="1"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const ListIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M7 5H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path d="M3 5H4" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <Path
        d="M7 12H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 12H4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M7 19H21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 19H4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const MoveIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M3 5L21 5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 12L21 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 19L21 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const BurgerMenuIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M7 5L21 5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M5 12L21 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 19L21 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const PlayNextIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M21.5 9.50781L12 9.50781"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M21.5 4.49219L12 4.49219"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M21.5 14.5078L2.5 14.5078"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M21.5 19.5078H2.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M8.69784 6.89709L2.84023 3.12279C2.34067 2.80036 1.66479 3.15124 1.66479 3.72971V11.2688C1.66479 11.8568 2.34067 12.1982 2.84023 11.8758L8.69784 8.10145C9.13863 7.82644 9.13863 7.18159 8.69784 6.89709Z"
        fill={color}
      />
    </Icon>
  );
};

const PlayLastIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M2.5 14.498L12 14.498"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M2.5 19.502L12 19.502"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M2.5 9.49805L21.5 9.49805"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M2.5 4.49805L21.5 4.49805"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M21.9046 15.8971L16.047 12.1228C15.5475 11.8004 14.8716 12.1512 14.8716 12.7297V20.2688C14.8716 20.8568 15.5475 21.1982 16.047 20.8758L21.9046 17.1015C22.3454 16.8264 22.3454 16.1816 21.9046 15.8971Z"
        fill={color}
      />
    </Icon>
  );
};

const UnsubscribeIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="12"
        cy="12"
        r="9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.5 12H16.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const EmailIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M21 12C21 10.1195 20.411 8.28625 19.3156 6.7577C18.2203 5.22915 16.6736 4.08209 14.893 3.47763C13.1123 2.87316 11.187 2.84166 9.38744 3.38754C7.58792 3.93341 6.00459 5.02925 4.85982 6.52115C3.71505 8.01304 3.06635 9.82604 3.00482 11.7055C2.94329 13.585 3.47203 15.4366 4.51677 17.0001C5.56152 18.5637 7.06979 19.7608 8.82975 20.4232C10.5897 21.0856 12.513 21.18 14.3294 20.6933"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Circle cx="12" cy="12" r="4" stroke={color} strokeWidth="1.5" />
      <Path
        d="M16 9V13.5C16 14.8807 17.1193 16 18.5 16V16C19.8807 16 21 14.8807 21 13.5V12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const PinIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12.398 17.804L12.7434 18.4697H12.7434L12.398 17.804ZM11.602 17.804L11.2566 18.4697H11.2566L11.602 17.804ZM18.25 9C18.25 11.2364 17.111 13.0661 15.7225 14.4666C14.3347 15.8664 12.7605 16.7711 12.0527 17.1382L12.7434 18.4697C13.5185 18.0677 15.2453 17.0785 16.7877 15.5227C18.3295 13.9676 19.75 11.78 19.75 9H18.25ZM12 2.75C15.4518 2.75 18.25 5.54822 18.25 9H19.75C19.75 4.71979 16.2802 1.25 12 1.25V2.75ZM5.75 9C5.75 5.54822 8.54822 2.75 12 2.75V1.25C7.71979 1.25 4.25 4.71979 4.25 9H5.75ZM11.9473 17.1382C11.2395 16.7711 9.66527 15.8664 8.27749 14.4666C6.88902 13.0661 5.75 11.2364 5.75 9H4.25C4.25 11.78 5.67049 13.9676 7.21227 15.5227C8.75474 17.0785 10.4815 18.0677 11.2566 18.4697L11.9473 17.1382ZM12.0527 17.1382C12.0164 17.157 11.9836 17.157 11.9473 17.1382L11.2566 18.4697C11.726 18.7132 12.274 18.7132 12.7434 18.4697L12.0527 17.1382ZM14.25 9C14.25 10.2426 13.2426 11.25 12 11.25V12.75C14.0711 12.75 15.75 11.0711 15.75 9H14.25ZM12 6.75C13.2426 6.75 14.25 7.75736 14.25 9H15.75C15.75 6.92893 14.0711 5.25 12 5.25V6.75ZM9.75 9C9.75 7.75736 10.7574 6.75 12 6.75V5.25C9.92893 5.25 8.25 6.92893 8.25 9H9.75ZM12 11.25C10.7574 11.25 9.75 10.2426 9.75 9H8.25C8.25 11.0711 9.92893 12.75 12 12.75V11.25Z"
        fill={color}
      />
      <Path
        d="M19.7942 17.5C20.5841 17.9561 21 18.4734 21 19C21 19.5266 20.5841 20.0439 19.7942 20.5C19.0043 20.9561 17.8682 21.3348 16.5 21.5981C15.1318 21.8614 13.5798 22 12 22C10.4202 22 8.86817 21.8614 7.5 21.5981C6.13183 21.3348 4.99569 20.9561 4.20577 20.5C3.41586 20.0439 3 19.5266 3 19C3 18.4734 3.41586 17.9561 4.20577 17.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const GenderIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M8.42285 16.4709C8.42285 16.0567 8.08706 15.7209 7.67285 15.7209C7.25864 15.7209 6.92285 16.0567 6.92285 16.4709H8.42285ZM6.92285 22.8003C6.92285 23.2146 7.25864 23.5503 7.67285 23.5503C8.08706 23.5503 8.42285 23.2146 8.42285 22.8003H6.92285ZM4.42383 18.6385C4.00961 18.6385 3.67383 18.9743 3.67383 19.3885C3.67383 19.8027 4.00961 20.1385 4.42383 20.1385V18.6385ZM10.9746 20.1385C11.3888 20.1385 11.7246 19.8027 11.7246 19.3885C11.7246 18.9743 11.3888 18.6385 10.9746 18.6385V20.1385ZM17.1963 5.75743C16.9045 6.05134 16.9061 6.52622 17.2 6.81809C17.4939 7.10996 17.9688 7.10831 18.2607 6.8144L17.1963 5.75743ZM22.5996 1.38086H23.3496C23.3496 1.17657 23.2663 0.981115 23.1189 0.839677C22.9714 0.698238 22.7727 0.623054 22.5686 0.631501L22.5996 1.38086ZM17.6975 0.833077C17.2836 0.850203 16.962 1.19959 16.9792 1.61345C16.9963 2.0273 17.3457 2.34892 17.7595 2.33179L17.6975 0.833077ZM21.8496 6.28592C21.8496 6.70013 22.1854 7.03592 22.5996 7.03592C23.0138 7.03592 23.3496 6.70013 23.3496 6.28592H21.8496ZM17.9324 10.5468C17.9324 13.2712 15.7238 15.4798 12.9994 15.4798V16.9798C16.5523 16.9798 19.4324 14.0996 19.4324 10.5468H17.9324ZM12.9994 15.4798C10.275 15.4798 8.0664 13.2712 8.0664 10.5468H6.5664C6.5664 14.0996 9.44656 16.9798 12.9994 16.9798V15.4798ZM8.0664 10.5468C8.0664 7.82235 10.275 5.61376 12.9994 5.61376V4.11376C9.44656 4.11376 6.5664 6.99392 6.5664 10.5468H8.0664ZM12.9994 5.61376C15.7238 5.61376 17.9324 7.82235 17.9324 10.5468H19.4324C19.4324 6.99392 16.5523 4.11376 12.9994 4.11376V5.61376ZM12.6058 10.5468C12.6058 13.2712 10.3972 15.4798 7.67276 15.4798V16.9798C11.2256 16.9798 14.1058 14.0996 14.1058 10.5468H12.6058ZM7.67276 15.4798C4.94833 15.4798 2.73975 13.2712 2.73975 10.5468H1.23975C1.23975 14.0996 4.1199 16.9798 7.67276 16.9798V15.4798ZM2.73975 10.5468C2.73975 7.82235 4.94833 5.61376 7.67276 5.61376V4.11376C4.1199 4.11376 1.23975 6.99392 1.23975 10.5468H2.73975ZM7.67276 5.61376C10.3972 5.61376 12.6058 7.82235 12.6058 10.5468H14.1058C14.1058 6.99392 11.2256 4.11376 7.67276 4.11376V5.61376ZM6.92285 16.4709V22.8003H8.42285V16.4709H6.92285ZM4.42383 20.1385H10.9746V18.6385H4.42383V20.1385ZM18.2607 6.8144L23.1318 1.90934L22.0674 0.852375L17.1963 5.75743L18.2607 6.8144ZM22.5686 0.631501L17.6975 0.833077L17.7595 2.33179L22.6306 2.13022L22.5686 0.631501ZM21.8496 1.38086V6.28592H23.3496V1.38086H21.8496Z"
        fill={color}
      />
    </Icon>
  );
};

const CastIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M2 20H2.01"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2 16.1C2.96089 16.296 3.84294 16.7702 4.53638 17.4636C5.22982 18.1571 5.70403 19.0391 5.9 20M2 12.05C4.03079 12.2759 5.92428 13.186 7.36911 14.6309C8.81395 16.0757 9.72414 17.9692 9.95 20M2 8V6C2 5.46957 2.21071 4.96086 2.58579 4.58579C2.96086 4.21071 3.46957 4 4 4H20C20.5304 4 21.0391 4.21071 21.4142 4.58579C21.7893 4.96086 22 5.46957 22 6V18C22 18.5304 21.7893 19.0391 21.4142 19.4142C21.0391 19.7893 20.5304 20 20 20H14"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const CloseIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M19 5L5 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5 5L19 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const QuestionIcon = ({ color = "#FFFFFF", strokeWidth, ...props }: Props) => {
  return (
    <Icon
      viewBox="0 0 24 24"
      {...props}
      color="transparent"
      strokeWidth={strokeWidth}
    >
      <Circle
        cx="12"
        cy="12"
        r="10"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
      />
      <Circle cx="12" cy="17.9805" r="0.75" fill={color} />
      <Path
        d="M12 16V15.1432C12 14.429 12.357 13.762 12.9512 13.3659L13.5497 12.9669C14.4558 12.3628 15 11.3459 15 10.2569V10C15 8.34315 13.6569 7 12 7V7C10.3431 7 9 8.34315 9 10V10"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
        strokeLinecap="round"
      />
    </Icon>
  );
};

const ReportIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M11.2505 16.2697C11.2505 15.8557 11.5865 15.5137 12.0005 15.5137C12.4145 15.5137 12.7505 15.8447 12.7505 16.2587V16.2697C12.7505 16.6837 12.4145 17.0197 12.0005 17.0197C11.5865 17.0197 11.2505 16.6837 11.2505 16.2697Z"
        fill={color}
      />
      <Path
        d="M4.79584 20.418H19.2778C20.4248 20.358 21.3068 19.381 21.2478 18.234C21.2348 18.002 21.1848 17.773 21.0968 17.559L13.8198 4.82298C13.2638 3.81798 11.9988 3.45398 10.9938 4.01098C10.6518 4.19898 10.3698 4.48098 10.1808 4.82298L2.90384 17.559C2.47184 18.623 2.98384 19.835 4.04684 20.268C4.26284 20.355 4.49084 20.405 4.72284 20.418"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.9902 13.3959V10.2959"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const SettingIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M14.1361 3.36144L14.8824 3.28681L14.1361 3.36144ZM13.9838 2.54161L13.3172 2.8854V2.8854L13.9838 2.54161ZM14.4311 4.81793L15.0274 4.36304L15.0274 4.36303L14.4311 4.81793ZM15.3595 5.20248L15.2595 4.45917H15.2595L15.3595 5.20248ZM16.5979 4.38113L17.0728 4.9616L17.0728 4.9616L16.5979 4.38113ZM17.2853 3.90918L17.5135 4.62361L17.2853 3.90918ZM17.9872 3.94419L18.2854 3.25602L18.2854 3.25602L17.9872 3.94419ZM18.6243 4.4822L18.094 5.01253V5.01253L18.6243 4.4822ZM19.5178 5.37567L20.0481 4.84534V4.84534L19.5178 5.37567ZM20.0558 6.01275L20.744 5.71457L20.744 5.71456L20.0558 6.01275ZM20.0908 6.71464L20.8052 6.94288L20.8052 6.94287L20.0908 6.71464ZM19.6188 7.4021L19.0384 6.92717L19.0384 6.92717L19.6188 7.4021ZM18.7975 8.64056L18.0542 8.54057V8.54058L18.7975 8.64056ZM19.182 9.56893L18.7271 10.1652V10.1652L19.182 9.56893ZM20.6385 9.86385L20.7132 9.11758L20.6385 9.86385ZM21.4584 10.0162L21.8022 9.34969L21.8022 9.34968L21.4584 10.0162ZM21.9299 10.5373L22.6274 10.2615V10.2615L21.9299 10.5373ZM21.93 13.4626L21.2325 13.1869L21.2325 13.1869L21.93 13.4626ZM21.4583 13.9838L21.8021 14.6504V14.6504L21.4583 13.9838ZM20.6386 14.1361L20.564 13.3899L20.5396 13.3923L20.5153 13.3963L20.6386 14.1361ZM20.6386 14.1361L20.7132 14.8824L20.7377 14.88L20.7619 14.8759L20.6386 14.1361ZM19.1825 14.4309L18.7278 13.8345V13.8345L19.1825 14.4309ZM18.7979 15.3596L18.0546 15.4597V15.4597L18.7979 15.3596ZM19.619 16.5976L19.0385 17.0725V17.0725L19.619 16.5976ZM20.0908 17.2848L19.3764 17.5131V17.5131L20.0908 17.2848ZM20.0558 17.9869L19.3676 17.6886L19.3676 17.6887L20.0558 17.9869ZM19.5179 18.6238L20.0483 19.1541H20.0483L19.5179 18.6238ZM18.6243 19.5174L18.094 18.987L18.094 18.987L18.6243 19.5174ZM17.9873 20.0554L18.2855 20.7435L18.2855 20.7435L17.9873 20.0554ZM17.2854 20.0904L17.0571 20.8048H17.0571L17.2854 20.0904ZM16.5979 19.6184L17.0729 19.0379L17.0664 19.0328L16.5979 19.6184ZM16.5979 19.6184L16.1229 20.1989L16.1294 20.2041L16.5979 19.6184ZM15.3595 18.7971L15.4595 18.0538H15.4595L15.3595 18.7971ZM14.4311 19.1816L15.0274 19.6365L15.0274 19.6365L14.4311 19.1816ZM14.1362 20.6383L13.3899 20.5637L14.1362 20.6383ZM13.9837 21.4585L13.3172 21.1146L13.3172 21.1146L13.9837 21.4585ZM13.4628 21.9299L13.187 21.2325H13.187L13.4628 21.9299ZM10.5373 21.9299L10.8131 21.2325L10.5373 21.9299ZM10.0162 21.4584L10.6828 21.1146V21.1146L10.0162 21.4584ZM9.86385 20.6385L9.11758 20.7132V20.7132L9.86385 20.6385ZM9.56892 19.182L8.97263 19.6369L8.97263 19.6369L9.56892 19.182ZM8.64057 18.7975L8.5406 18.0542H8.5406L8.64057 18.7975ZM7.40208 19.6189L6.92715 19.0384L6.91527 19.0481L6.9038 19.0583L7.40208 19.6189ZM7.40206 19.6189L7.87699 20.1993L7.88887 20.1896L7.90034 20.1794L7.40206 19.6189ZM6.71458 20.0908L6.9428 20.8053H6.9428L6.71458 20.0908ZM6.01272 20.0558L5.71454 20.744H5.71454L6.01272 20.0558ZM5.37561 19.5178L5.90594 18.9875H5.90594L5.37561 19.5178ZM4.48217 18.6243L3.95184 19.1547L3.95184 19.1547L4.48217 18.6243ZM3.94414 17.9873L4.63232 17.6891H4.63232L3.94414 17.9873ZM3.90913 17.2854L4.62356 17.5136L4.62356 17.5136L3.90913 17.2854ZM4.3811 16.5979L4.96157 17.0728L4.96157 17.0728L4.3811 16.5979ZM5.20247 15.3594L5.94578 15.4594L5.20247 15.3594ZM4.81792 14.4311L5.27282 13.8348L5.27282 13.8348L4.81792 14.4311ZM3.36143 14.1361L3.2868 14.8824H3.2868L3.36143 14.1361ZM2.54161 13.9838L2.8854 13.3172H2.8854L2.54161 13.9838ZM2.07005 13.4627L1.37258 13.7384L1.37258 13.7385L2.07005 13.4627ZM2.07008 10.5372L1.37265 10.2614L1.37265 10.2614L2.07008 10.5372ZM2.54152 10.0163L2.19767 9.34975L2.19766 9.34975L2.54152 10.0163ZM3.36155 9.86384V9.11384H3.32414L3.28692 9.11757L3.36155 9.86384ZM3.36156 9.86384V10.6138H3.39896L3.43619 10.6101L3.36156 9.86384ZM4.81842 9.56881L4.36344 8.97258L4.36343 8.97258L4.81842 9.56881ZM5.20287 8.64066L5.94619 8.54078V8.54078L5.20287 8.64066ZM4.38128 7.40182L4.96175 6.92689H4.96175L4.38128 7.40182ZM3.90914 6.71405L4.6236 6.48592H4.6236L3.90914 6.71405ZM3.94413 6.01243L3.25591 5.71434L3.25591 5.71434L3.94413 6.01243ZM4.48233 5.37509L5.01266 5.90542L5.01266 5.90542L4.48233 5.37509ZM5.37565 4.48177L4.84532 3.95144L5.37565 4.48177ZM6.01277 3.94373L5.71459 3.25555L5.71459 3.25555L6.01277 3.94373ZM6.71463 3.90872L6.94285 3.19429L6.94285 3.19429L6.71463 3.90872ZM7.4022 4.38076L7.87713 3.80029V3.80029L7.4022 4.38076ZM8.64044 5.20207L8.74054 4.45878V4.45878L8.64044 5.20207ZM9.56907 4.81742L8.9727 4.36261L9.56907 4.81742ZM9.86387 3.36131L10.6101 3.43593V3.43593L9.86387 3.36131ZM10.0162 2.5417L9.34959 2.19798L9.34959 2.19798L10.0162 2.5417ZM10.5374 2.07001L10.8131 2.7675L10.8131 2.7675L10.5374 2.07001ZM13.4627 2.07005L13.7385 1.37258L13.7385 1.37258L13.4627 2.07005ZM14.8824 3.28681C14.8617 3.07989 14.8429 2.88819 14.8161 2.7282C14.788 2.56083 14.744 2.37935 14.6503 2.19782L13.3172 2.8854C13.3109 2.87319 13.3214 2.88479 13.3368 2.97658C13.3534 3.07575 13.3672 3.20932 13.3899 3.43607L14.8824 3.28681ZM15.0274 4.36303C15.0533 4.39708 15.0249 4.38487 14.9881 4.18023C14.9526 3.98276 14.9247 3.70983 14.8824 3.28681L13.3899 3.43607C13.4297 3.83391 13.4634 4.17663 13.5118 4.44589C13.559 4.70798 13.637 5.01358 13.8348 5.27282L15.0274 4.36303ZM15.2595 4.45917C15.1704 4.47115 15.0818 4.43445 15.0274 4.36304L13.8348 5.27281C14.2161 5.77271 14.8363 6.02961 15.4594 5.94578L15.2595 4.45917ZM16.1229 3.80066C15.7939 4.06987 15.5812 4.24316 15.4165 4.35767C15.2457 4.47633 15.217 4.46488 15.2595 4.45917L15.4594 5.94578C15.7826 5.90231 16.0538 5.74139 16.2725 5.58941C16.4972 5.43328 16.7634 5.21478 17.0728 4.9616L16.1229 3.80066ZM17.0571 3.19476C16.8625 3.25691 16.7031 3.3541 16.5648 3.45258C16.4327 3.54672 16.2839 3.66898 16.1229 3.80066L17.0728 4.9616C17.2492 4.8173 17.3533 4.73258 17.4352 4.67423C17.511 4.62022 17.5266 4.61943 17.5135 4.62361L17.0571 3.19476ZM18.2854 3.25602C17.8969 3.08766 17.4604 3.06589 17.0571 3.19476L17.5135 4.62361C17.5712 4.6052 17.6335 4.60831 17.689 4.63236L18.2854 3.25602ZM19.1546 3.95187C19.0076 3.80483 18.8717 3.66836 18.7496 3.56154C18.6218 3.4498 18.4728 3.33723 18.2854 3.25602L17.689 4.63236C17.6764 4.6269 17.6919 4.62924 17.7619 4.69053C17.8376 4.75673 17.9328 4.8514 18.094 5.01253L19.1546 3.95187ZM20.0481 4.84534L19.1546 3.95187L18.094 5.01253L18.9874 5.906L20.0481 4.84534ZM20.744 5.71456C20.6627 5.52714 20.5502 5.37815 20.4384 5.25041C20.3316 5.12831 20.1951 4.99239 20.0481 4.84534L18.9874 5.906C19.1486 6.06713 19.2432 6.16235 19.3094 6.23804C19.3707 6.30809 19.3731 6.32355 19.3676 6.31094L20.744 5.71456ZM20.8052 6.94287C20.9341 6.53951 20.9123 6.10311 20.744 5.71457L19.3676 6.31094C19.3917 6.36644 19.3948 6.42879 19.3764 6.48642L20.8052 6.94287ZM20.1993 7.87703C20.331 7.71608 20.4532 7.56725 20.5474 7.43512C20.6459 7.2969 20.7431 7.13745 20.8052 6.94288L19.3764 6.48641C19.3805 6.47332 19.3797 6.48893 19.3257 6.56474C19.2674 6.64664 19.1827 6.7508 19.0384 6.92717L20.1993 7.87703ZM19.5408 8.74054C19.5351 8.78298 19.5236 8.75426 19.6423 8.58352C19.7568 8.41875 19.9301 8.20607 20.1993 7.87703L19.0384 6.92717C18.7852 7.23663 18.5667 7.50282 18.4105 7.72748C18.2585 7.94616 18.0976 8.21742 18.0542 8.54057L19.5408 8.74054ZM19.6369 8.97263C19.5655 8.91815 19.5288 8.82956 19.5408 8.74054L18.0542 8.54058C17.9703 9.16369 18.2272 9.78388 18.7271 10.1652L19.6369 8.97263ZM20.7132 9.11758C20.2901 9.07527 20.0172 9.04742 19.8197 9.01189C19.6151 8.97506 19.6029 8.94666 19.6369 8.97263L18.7271 10.1652C18.9863 10.363 19.292 10.441 19.5541 10.4882C19.8233 10.5366 20.166 10.5703 20.5639 10.6101L20.7132 9.11758ZM21.8022 9.34968C21.6207 9.25605 21.4392 9.21202 21.2718 9.18392C21.1118 9.15705 20.9201 9.13827 20.7132 9.11758L20.5639 10.6101C20.7907 10.6328 20.9242 10.6466 21.0234 10.6632C21.1152 10.6786 21.1268 10.6891 21.1146 10.6828L21.8022 9.34968ZM22.6274 10.2615C22.4717 9.86775 22.1785 9.54379 21.8022 9.34969L21.1146 10.6828C21.1684 10.7105 21.2102 10.7568 21.2325 10.8131L22.6274 10.2615ZM22.75 11.3682C22.75 11.1603 22.7504 10.9677 22.7396 10.8058C22.7283 10.6364 22.7025 10.4515 22.6274 10.2615L21.2325 10.8131C21.2274 10.8003 21.2367 10.8129 21.2429 10.9057C21.2496 11.0061 21.25 11.1404 21.25 11.3682H22.75ZM22.75 12.6319V11.3682H21.25V12.6319H22.75ZM22.6275 13.7383C22.7025 13.5484 22.7283 13.3635 22.7396 13.1942C22.7504 13.0324 22.75 12.8398 22.75 12.6319H21.25C21.25 12.8597 21.2496 12.9939 21.2429 13.0943C21.2367 13.1871 21.2274 13.1997 21.2325 13.1869L22.6275 13.7383ZM21.8021 14.6504C22.1785 14.4563 22.4718 14.1322 22.6275 13.7383L21.2325 13.1869C21.2103 13.2432 21.1684 13.2895 21.1146 13.3172L21.8021 14.6504ZM20.7133 14.8824C20.9201 14.8617 21.1118 14.8429 21.2718 14.8161C21.4391 14.788 21.6205 14.744 21.8021 14.6504L21.1146 13.3172C21.1268 13.3109 21.1152 13.3214 21.0234 13.3368C20.9243 13.3534 20.7907 13.3672 20.564 13.3899L20.7133 14.8824ZM20.7619 14.8759L20.7619 14.8759L20.5153 13.3963L20.5153 13.3963L20.7619 14.8759ZM19.6373 15.0273C19.6033 15.0533 19.6155 15.0249 19.8201 14.9881C20.0175 14.9525 20.2903 14.9247 20.7132 14.8824L20.564 13.3899C20.1663 13.4296 19.8236 13.4633 19.5545 13.5118C19.2925 13.5589 18.9869 13.6369 18.7278 13.8345L19.6373 15.0273ZM19.5412 15.2595C19.5292 15.1704 19.5659 15.0818 19.6373 15.0273L18.7278 13.8345C18.2276 14.2159 17.9706 14.8364 18.0546 15.4597L19.5412 15.2595ZM20.1994 16.1227C19.9303 15.7937 19.7571 15.5811 19.6426 15.4164C19.524 15.2458 19.5354 15.2171 19.5412 15.2595L18.0546 15.4597C18.0981 15.7828 18.259 16.0539 18.4109 16.2725C18.567 16.4971 18.7854 16.7632 19.0385 17.0725L20.1994 16.1227ZM20.8052 17.0565C20.743 16.862 20.6459 16.7026 20.5474 16.5644C20.4533 16.4323 20.3311 16.2835 20.1994 16.1227L19.0385 17.0725C19.1828 17.2488 19.2675 17.3529 19.3258 17.4348C19.3798 17.5106 19.3806 17.5262 19.3764 17.5131L20.8052 17.0565ZM20.7439 18.2852C20.9124 17.8965 20.9342 17.46 20.8052 17.0565L19.3764 17.5131C19.3948 17.5708 19.3917 17.6331 19.3676 17.6886L20.7439 18.2852ZM20.0483 19.1541C20.1952 19.0071 20.3317 18.8712 20.4384 18.7492C20.5502 18.6215 20.6627 18.4726 20.7439 18.2852L19.3676 17.6887C19.3731 17.676 19.3708 17.6915 19.3095 17.7615C19.2433 17.8372 19.1487 17.9324 18.9876 18.0934L20.0483 19.1541ZM19.1547 20.0477L20.0483 19.1541L18.9876 18.0934L18.094 18.987L19.1547 20.0477ZM18.2855 20.7435C18.4729 20.6623 18.6219 20.5498 18.7496 20.438C18.8717 20.3312 19.0076 20.1947 19.1547 20.0477L18.094 18.987C17.9329 19.1482 17.8377 19.2428 17.762 19.309C17.6919 19.3703 17.6765 19.3727 17.6891 19.3672L18.2855 20.7435ZM17.0571 20.8048C17.4605 20.9337 17.8969 20.9119 18.2855 20.7435L17.6891 19.3672C17.6336 19.3912 17.5712 19.3944 17.5136 19.3759L17.0571 20.8048ZM16.123 20.1989C16.2839 20.3306 16.4328 20.4528 16.5649 20.547C16.7031 20.6455 16.8626 20.7426 17.0571 20.8048L17.5136 19.3759C17.5267 19.3801 17.5111 19.3793 17.4353 19.3253C17.3534 19.267 17.2492 19.1823 17.0728 19.038L16.123 20.1989ZM16.1294 20.2041L16.1294 20.2041L17.0664 19.0328L17.0664 19.0328L16.1294 20.2041ZM15.2595 19.5404C15.2171 19.5347 15.2458 19.5232 15.4165 19.6419C15.5813 19.7564 15.794 19.9297 16.123 20.1989L17.0728 19.0379C16.7634 18.7848 16.4972 18.5663 16.2726 18.4101C16.0539 18.2582 15.7826 18.0972 15.4595 18.0538L15.2595 19.5404ZM15.0274 19.6365C15.0819 19.5651 15.1705 19.5284 15.2595 19.5404L15.4595 18.0538C14.8364 17.9699 14.2161 18.2268 13.8348 18.7267L15.0274 19.6365ZM14.8824 20.7129C14.9248 20.2899 14.9526 20.0169 14.9881 19.8194C15.025 19.6147 15.0534 19.6025 15.0274 19.6365L13.8348 18.7267C13.637 18.986 13.559 19.2916 13.5119 19.5537C13.4634 19.823 13.4297 20.1658 13.3899 20.5637L14.8824 20.7129ZM14.6502 21.8024C14.7439 21.6208 14.788 21.4392 14.8161 21.2718C14.843 21.1117 14.8617 20.92 14.8824 20.7129L13.3899 20.5637C13.3672 20.7905 13.3535 20.9242 13.3368 21.0234C13.3214 21.1152 13.3109 21.1269 13.3172 21.1146L14.6502 21.8024ZM13.7386 22.6273C14.1323 22.4717 14.4562 22.1786 14.6502 21.8024L13.3172 21.1146C13.2895 21.1684 13.2432 21.2102 13.187 21.2325L13.7386 22.6273ZM12.6316 22.75C12.8397 22.75 13.0323 22.7504 13.1942 22.7396C13.3636 22.7283 13.5486 22.7025 13.7386 22.6273L13.187 21.2325C13.1997 21.2274 13.1872 21.2367 13.0943 21.2429C12.9939 21.2496 12.8596 21.25 12.6316 21.25V22.75ZM11.3682 22.75H12.6316V21.25H11.3682V22.75ZM10.2615 22.6274C10.4515 22.7025 10.6364 22.7283 10.8058 22.7396C10.9677 22.7504 11.1603 22.75 11.3682 22.75V21.25C11.1404 21.25 11.0061 21.2496 10.9057 21.2429C10.8129 21.2367 10.8003 21.2274 10.8131 21.2325L10.2615 22.6274ZM9.34968 21.8022C9.54379 22.1785 9.86775 22.4717 10.2615 22.6274L10.8131 21.2325C10.7568 21.2102 10.7105 21.1684 10.6828 21.1146L9.34968 21.8022ZM9.11758 20.7132C9.13827 20.9201 9.15705 21.1118 9.18392 21.2718C9.21202 21.4392 9.25605 21.6207 9.34968 21.8022L10.6828 21.1146C10.6891 21.1268 10.6786 21.1152 10.6632 21.0234C10.6466 20.9242 10.6328 20.7907 10.6101 20.5639L9.11758 20.7132ZM8.97263 19.6369C8.94666 19.6029 8.97506 19.6151 9.01189 19.8197C9.04742 20.0172 9.07527 20.2901 9.11758 20.7132L10.6101 20.5639C10.5703 20.1661 10.5366 19.8233 10.4882 19.5541C10.441 19.2919 10.363 18.9863 10.1652 18.7271L8.97263 19.6369ZM8.74054 19.5408C8.82956 19.5288 8.91815 19.5655 8.97263 19.6369L10.1652 18.7271C9.78387 18.2272 9.1637 17.9704 8.5406 18.0542L8.74054 19.5408ZM7.877 20.1993C8.20605 19.9301 8.41875 19.7568 8.58352 19.6423C8.75426 19.5236 8.78298 19.5351 8.74054 19.5408L8.5406 18.0542C8.21744 18.0976 7.94617 18.2586 7.72748 18.4105C7.50281 18.5667 7.23661 18.7852 6.92715 19.0384L7.877 20.1993ZM7.90034 20.1794L7.90035 20.1794L6.9038 19.0583L6.90379 19.0583L7.90034 20.1794ZM6.9428 20.8053C7.13738 20.7431 7.29684 20.6459 7.43507 20.5474C7.5672 20.4533 7.71604 20.331 7.87699 20.1993L6.92714 19.0384C6.75076 19.1827 6.6466 19.2674 6.56469 19.3258C6.48888 19.3798 6.47327 19.3806 6.48636 19.3764L6.9428 20.8053ZM5.71454 20.744C6.10307 20.9124 6.53946 20.9341 6.9428 20.8053L6.48636 19.3764C6.42874 19.3948 6.3664 19.3917 6.3109 19.3677L5.71454 20.744ZM4.84528 20.0481C4.99233 20.1952 5.12826 20.3316 5.25037 20.4385C5.37811 20.5502 5.52711 20.6628 5.71454 20.744L6.3109 19.3677C6.32351 19.3731 6.30805 19.3708 6.23799 19.3095C6.1623 19.2433 6.06708 19.1486 5.90594 18.9875L4.84528 20.0481ZM3.95184 19.1547L4.84528 20.0481L5.90594 18.9875L5.0125 18.094L3.95184 19.1547ZM3.25596 18.2854C3.33717 18.4729 3.44975 18.6219 3.56149 18.7496C3.66831 18.8717 3.80479 19.0076 3.95184 19.1547L5.0125 18.094C4.85136 17.9329 4.75669 17.8377 4.69048 17.762C4.62919 17.6919 4.62685 17.6765 4.63232 17.6891L3.25596 18.2854ZM3.1947 17.0571C3.06585 17.4605 3.08761 17.8969 3.25596 18.2854L4.63232 17.6891C4.60827 17.6336 4.60516 17.5712 4.62356 17.5136L3.1947 17.0571ZM3.80064 16.123C3.66895 16.2839 3.54667 16.4328 3.45253 16.5649C3.35405 16.7031 3.25686 16.8626 3.1947 17.0571L4.62356 17.5136C4.61938 17.5267 4.62017 17.5111 4.67419 17.4353C4.73254 17.3534 4.81726 17.2492 4.96157 17.0728L3.80064 16.123ZM4.45917 15.2595C4.46488 15.217 4.47632 15.2457 4.35766 15.4165C4.24315 15.5812 4.06985 15.7939 3.80064 16.123L4.96157 17.0728C5.21476 16.7634 5.43327 16.4972 5.5894 16.2725C5.74138 16.0538 5.90231 15.7826 5.94578 15.4594L4.45917 15.2595ZM4.36303 15.0274C4.43444 15.0818 4.47114 15.1704 4.45917 15.2595L5.94578 15.4594C6.0296 14.8363 5.7727 14.2161 5.27282 13.8348L4.36303 15.0274ZM3.2868 14.8824C3.70983 14.9247 3.98275 14.9526 4.18022 14.9881C4.38486 15.0249 4.39707 15.0533 4.36303 15.0274L5.27282 13.8348C5.01358 13.637 4.70798 13.559 4.44589 13.5118C4.17663 13.4634 3.8339 13.4296 3.43606 13.3899L3.2868 14.8824ZM2.19782 14.6503C2.37936 14.744 2.56083 14.788 2.7282 14.8161C2.88819 14.8429 3.07988 14.8617 3.2868 14.8824L3.43606 13.3899C3.20931 13.3672 3.07575 13.3534 2.97658 13.3368C2.88479 13.3214 2.87319 13.3109 2.8854 13.3172L2.19782 14.6503ZM1.37258 13.7385C1.52828 14.1322 1.82148 14.4562 2.19782 14.6503L2.8854 13.3172C2.83164 13.2895 2.78975 13.2432 2.76751 13.1869L1.37258 13.7385ZM1.25 12.6318C1.25 12.8397 1.24961 13.0323 1.26042 13.1942C1.27173 13.3635 1.29748 13.5485 1.37258 13.7384L2.76751 13.1869C2.77257 13.1997 2.76329 13.1871 2.75709 13.0943C2.75039 12.9939 2.75 12.8597 2.75 12.6318H1.25ZM1.25 11.3683V12.6318H2.75V11.3683H1.25ZM1.37265 10.2614C1.29751 10.4514 1.27174 10.6364 1.26043 10.8058C1.24961 10.9677 1.25 11.1603 1.25 11.3683H2.75C2.75 11.1404 2.75039 11.0061 2.75709 10.9057C2.7633 10.8128 2.77258 10.8003 2.76752 10.813L1.37265 10.2614ZM2.19766 9.34975C1.82145 9.54384 1.52834 9.86772 1.37265 10.2614L2.76752 10.813C2.78976 10.7568 2.83164 10.7105 2.88538 10.6828L2.19766 9.34975ZM3.28692 9.11757C3.07995 9.13826 2.88821 9.15705 2.72817 9.18392C2.56076 9.21204 2.37924 9.25608 2.19767 9.34975L2.88538 10.6828C2.87316 10.6891 2.88477 10.6786 2.97658 10.6632C3.07578 10.6466 3.20937 10.6328 3.43618 10.6101L3.28692 9.11757ZM3.36155 9.11384H3.36155V10.6138H3.36155V9.11384ZM3.36156 9.11384H3.36155V10.6138H3.36156V9.11384ZM4.36343 8.97258C4.39748 8.9466 4.38527 8.97501 4.18059 9.01185C3.98306 9.0474 3.71006 9.07525 3.28693 9.11757L3.43619 10.6101C3.83414 10.5703 4.17695 10.5366 4.44628 10.4881C4.70844 10.4409 5.01412 10.3629 5.2734 10.165L4.36343 8.97258ZM4.45955 8.74054C4.47151 8.82954 4.43482 8.91811 4.36344 8.97258L5.2734 10.165C5.77308 9.78373 6.02989 9.16374 5.94619 8.54078L4.45955 8.74054ZM3.80081 7.87675C4.07011 8.20589 4.24347 8.41865 4.35801 8.58347C4.47671 8.75427 4.46525 8.78299 4.45955 8.74054L5.94619 8.54078C5.90275 8.21754 5.74179 7.94619 5.58977 7.72745C5.43359 7.50272 5.21502 7.23645 4.96175 6.92689L3.80081 7.87675ZM3.19467 6.94218C3.25683 7.13684 3.35405 7.29637 3.45257 7.43465C3.54674 7.56683 3.66906 7.71572 3.80081 7.87675L4.96175 6.92689C4.81738 6.75044 4.73261 6.64623 4.67424 6.56429C4.6202 6.48844 4.61942 6.47282 4.6236 6.48592L3.19467 6.94218ZM3.25591 5.71434C3.08768 6.10275 3.06593 6.53896 3.19467 6.94218L4.6236 6.48592C4.60521 6.42832 4.60831 6.36601 4.63235 6.31052L3.25591 5.71434ZM3.952 4.84476C3.8049 4.99186 3.66838 5.12784 3.56152 5.24999C3.44974 5.37778 3.33713 5.52684 3.25591 5.71434L4.63235 6.31052C4.62688 6.32314 4.62922 6.30767 4.69053 6.23759C4.75676 6.16187 4.85147 6.06662 5.01266 5.90542L3.952 4.84476ZM4.84532 3.95144L3.952 4.84476L5.01266 5.90542L5.90598 5.0121L4.84532 3.95144ZM4.84533 3.95144L4.84532 3.95144L5.90598 5.0121L5.90599 5.0121L4.84533 3.95144ZM5.71459 3.25555C5.52716 3.33676 5.37816 3.44934 5.25042 3.56109C5.12831 3.66791 4.99238 3.80438 4.84533 3.95144L5.90599 5.0121C6.06713 4.85095 6.16235 4.75628 6.23804 4.69007C6.3081 4.62878 6.32356 4.62644 6.31094 4.63191L5.71459 3.25555ZM6.94285 3.19429C6.5395 3.06544 6.10312 3.08721 5.71459 3.25555L6.31094 4.63191C6.36645 4.60786 6.42879 4.60475 6.48641 4.62316L6.94285 3.19429ZM7.87713 3.80029C7.71614 3.66858 7.56729 3.54629 7.43514 3.45214C7.29691 3.35366 7.13744 3.25645 6.94285 3.19429L6.48641 4.62316C6.4733 4.61897 6.48892 4.61976 6.56476 4.67379C6.64668 4.73216 6.75087 4.8169 6.92727 4.96123L7.87713 3.80029ZM8.74054 4.45878C8.78298 4.46449 8.75427 4.47593 8.58353 4.35726C8.41879 4.24276 8.20612 4.06947 7.87713 3.80029L6.92727 4.96123C7.23669 5.21439 7.50284 5.43286 7.72745 5.58898C7.94608 5.74093 8.21728 5.90185 8.54034 5.94536L8.74054 4.45878ZM8.9727 4.36261C8.91822 4.43406 8.82959 4.47077 8.74054 4.45878L8.54034 5.94536C9.16364 6.0293 9.78405 5.77232 10.1654 5.27222L8.9727 4.36261ZM9.11759 3.28668C9.0753 3.70958 9.04746 3.98243 9.01194 4.17985C8.97513 4.38444 8.94674 4.39665 8.9727 4.36261L10.1654 5.27222C10.3631 5.01303 10.4411 4.70751 10.4882 4.44549C10.5367 4.1763 10.5704 3.83367 10.6101 3.43593L9.11759 3.28668ZM9.34959 2.19798C9.256 2.37948 9.212 2.5609 9.18391 2.72823C9.15705 2.88818 9.13828 3.07981 9.11759 3.28668L10.6101 3.43593C10.6328 3.20925 10.6466 3.07573 10.6632 2.97658C10.6786 2.88481 10.6891 2.87321 10.6828 2.88543L9.34959 2.19798ZM10.2617 1.37252C9.86779 1.52822 9.54371 1.82151 9.34959 2.19798L10.6828 2.88543C10.7105 2.83164 10.7568 2.78975 10.8131 2.7675L10.2617 1.37252ZM11.3681 1.25C11.1602 1.25 10.9676 1.24961 10.8058 1.26042C10.6365 1.27172 10.4516 1.29746 10.2617 1.37252L10.8131 2.7675C10.8003 2.77255 10.8129 2.76328 10.9057 2.75708C11.0061 2.75039 11.1403 2.75 11.3681 2.75V1.25ZM12.6318 1.25H11.3681V2.75H12.6318V1.25ZM13.7385 1.37258C13.5485 1.29748 13.3635 1.27173 13.1942 1.26042C13.0323 1.24961 12.8397 1.25 12.6318 1.25V2.75C12.8597 2.75 12.9939 2.75039 13.0943 2.75709C13.1871 2.76329 13.1997 2.77257 13.1869 2.76751L13.7385 1.37258ZM14.6503 2.19782C14.4562 1.82148 14.1322 1.52828 13.7385 1.37258L13.1869 2.76751C13.2432 2.78975 13.2895 2.83164 13.3172 2.8854L14.6503 2.19782ZM15.25 12C15.25 13.7949 13.7949 15.25 12 15.25V16.75C14.6234 16.75 16.75 14.6234 16.75 12H15.25ZM12 8.75C13.7949 8.75 15.25 10.2051 15.25 12H16.75C16.75 9.37665 14.6234 7.25 12 7.25V8.75ZM8.75 12C8.75 10.2051 10.2051 8.75 12 8.75V7.25C9.37665 7.25 7.25 9.37665 7.25 12H8.75ZM12 15.25C10.2051 15.25 8.75 13.7949 8.75 12H7.25C7.25 14.6234 9.37665 16.75 12 16.75V15.25Z"
        fill={color}
      />
    </Icon>
  );
};

const ResetIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M14.2857 13.1111L9.71429 17.5556L14.2857 22M5.07181 13.6667C4.16545 12.1404 3.81911 10.3601 4.08954 8.61748C4.35996 6.87483 5.23112 5.27313 6.56029 4.07478C7.88946 2.87642 9.59784 2.15247 11.4055 2.02151C13.2133 1.89055 15.0131 2.36036 16.5103 3.35396C18.0075 4.34757 19.1132 5.80605 19.6462 7.4905C20.1793 9.17494 20.1082 10.9855 19.4445 12.6255C18.7808 14.2655 17.5639 15.6377 15.9931 16.5174C14.4224 17.3971 12.5909 17.732 10.7987 17.4674"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const FilterIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M4.22222 12L4.22222 3M4.22222 12C2.99492 12 2 13.0074 2 14.25C2 15.4926 2.99492 16.5 4.22222 16.5M4.22222 12C5.44952 12 6.44444 13.0074 6.44444 14.25C6.44444 15.4926 5.44952 16.5 4.22222 16.5M19.7778 21L19.7778 17.625M19.7778 17.625C21.0051 17.625 22 16.6176 22 15.375C22 14.1324 21.0051 13.125 19.7778 13.125M19.7778 17.625C18.5505 17.625 17.5556 16.6176 17.5556 15.375C17.5556 14.1324 18.5505 13.125 19.7778 13.125M4.22222 21L4.22222 16.5M19.7778 13.125L19.7778 3M12 6.375V3M12 6.375C10.7727 6.375 9.77778 7.38236 9.77778 8.625C9.77778 9.86764 10.7727 10.875 12 10.875M12 6.375C13.2273 6.375 14.2222 7.38236 14.2222 8.625C14.2222 9.86764 13.2273 10.875 12 10.875M12 21L12 10.875"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const FullScreenIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="2"
        y="4"
        width="20"
        height="16"
        rx="1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M5 11V7M5 7H9M5 7L9 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19 13V17M19 17H15M19 17L15 13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const SmallScreenIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="2"
        y="4"
        width="20"
        height="16"
        rx="1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M9 7V11M9 11H5M9 11L5 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 17V13M15 13H19M15 13L19 17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const FullScreenTwoIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9 4H7C5.58579 4 4.87868 4 4.43934 4.43934C4 4.87868 4 5.58579 4 7V9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M9 20H7C5.58579 20 4.87868 20 4.43934 19.5607C4 19.1213 4 18.4142 4 17V15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M15 4H17C18.4142 4 19.1213 4 19.5607 4.43934C20 4.87868 20 5.58579 20 7V9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M15 20H17C18.4142 20 19.1213 20 19.5607 19.5607C20 19.1213 20 18.4142 20 17V15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const ScaleUpIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="2"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M8.5 5.5H5.5M5.5 5.5V8.5M5.5 5.5L10 10"
        stroke={color}
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Rect x="12" y="12" width="10" height="10" rx="2" fill={color} />
    </Icon>
  );
};

const DoubleCheckIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M8 13L12.2277 16.3821C12.6556 16.7245 13.2793 16.6586 13.6263 16.2345L22 6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.364 12.8506L15.5805 6.47495C15.8428 6.15437 15.7956 5.68185 15.475 5.41955C15.1544 5.15726 14.6819 5.20451 14.4196 5.52509L9.21166 11.8903L10.364 12.8506ZM8.46424 15.1726L7.31186 14.2123L6.02662 15.7831C5.94179 15.8868 5.79031 15.9052 5.68313 15.8248L2.45004 13.4C2.11867 13.1515 1.64857 13.2187 1.40004 13.55C1.15152 13.8814 1.21867 14.3515 1.55004 14.6L4.78313 17.0248C5.53334 17.5875 6.59373 17.4588 7.18756 16.733L8.46424 15.1726Z"
        fill={color}
      />
    </Icon>
  );
};

const TimeIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 6.61719V12.6172L16 14.6172"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const AddIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 5L12 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M19 12L5 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const Next30Icon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 7.5L15 4.5L12 1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.7942 9C20.8139 10.7661 21.2035 12.8261 20.8993 14.8426C20.5951 16.8591 19.615 18.7125 18.1197 20.0992C16.6244 21.4859 14.7024 22.3236 12.6688 22.4751C10.6351 22.6267 8.61023 22.083 6.92592 20.9333C5.2416 19.7835 3.99769 18.0959 3.39797 16.1467C2.79825 14.1976 2.87827 12.1025 3.62493 10.2048C4.37158 8.30711 5.74061 6.71923 7.50772 5.70132C9.27483 4.68341 11.3352 4.29582 13.3514 4.60205"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9.31836 16.5938C10.4473 16.5938 11.2754 15.8984 11.2754 14.957V14.9492C11.2754 14.1484 10.7168 13.6367 9.89648 13.5664V13.5508C10.5996 13.4023 11.0918 12.9258 11.0918 12.2305V12.2227C11.0918 11.3672 10.3848 10.7695 9.31055 10.7695C8.25586 10.7695 7.5293 11.3828 7.43945 12.3008L7.43555 12.3398H8.11133L8.11523 12.3008C8.17383 11.7305 8.64648 11.3789 9.31055 11.3789C9.99805 11.3789 10.3848 11.7188 10.3848 12.3086V12.3164C10.3848 12.8789 9.91602 13.293 9.24414 13.293H8.56836V13.8867H9.27539C10.0645 13.8867 10.5605 14.2734 10.5605 14.9648V14.9727C10.5605 15.5703 10.0566 15.9844 9.31836 15.9844C8.56836 15.9844 8.05664 15.6016 8.00195 15.0469L7.99805 15.0078H7.32227L7.32617 15.0547C7.40039 15.9453 8.1543 16.5938 9.31836 16.5938Z"
        fill={color}
      />
      <Path
        d="M14.3027 16.6328C15.5488 16.6328 16.2988 15.4961 16.2988 13.6836V13.6758C16.2988 11.8633 15.5488 10.7305 14.3027 10.7305C13.0566 10.7305 12.3145 11.8633 12.3145 13.6758V13.6836C12.3145 15.4961 13.0566 16.6328 14.3027 16.6328ZM14.3027 16.0195C13.4941 16.0195 13.0215 15.1211 13.0215 13.6836V13.6758C13.0215 12.2383 13.4941 11.3477 14.3027 11.3477C15.1113 11.3477 15.5918 12.2383 15.5918 13.6758V13.6836C15.5918 15.1211 15.1113 16.0195 14.3027 16.0195Z"
        fill={color}
      />
    </Icon>
  );
};

const Previews30Icon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 7.5L9 4.5L12 1.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M4.20577 9C3.18611 10.7661 2.79648 12.8261 3.10071 14.8426C3.40494 16.8591 4.38499 18.7125 5.88031 20.0992C7.37563 21.4859 9.29756 22.3236 11.3312 22.4751C13.3649 22.6267 15.3898 22.083 17.0741 20.9333C18.7584 19.7835 20.0023 18.0959 20.602 16.1467C21.2018 14.1976 21.1217 12.1025 20.3751 10.2048C19.6284 8.30711 18.2594 6.71923 16.4923 5.70132C14.7252 4.68341 12.6648 4.29582 10.6486 4.60205"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9.31836 16.5938C10.4473 16.5938 11.2754 15.8984 11.2754 14.957V14.9492C11.2754 14.1484 10.7168 13.6367 9.89648 13.5664V13.5508C10.5996 13.4023 11.0918 12.9258 11.0918 12.2305V12.2227C11.0918 11.3672 10.3848 10.7695 9.31055 10.7695C8.25586 10.7695 7.5293 11.3828 7.43945 12.3008L7.43555 12.3398H8.11133L8.11523 12.3008C8.17383 11.7305 8.64648 11.3789 9.31055 11.3789C9.99805 11.3789 10.3848 11.7188 10.3848 12.3086V12.3164C10.3848 12.8789 9.91602 13.293 9.24414 13.293H8.56836V13.8867H9.27539C10.0645 13.8867 10.5605 14.2734 10.5605 14.9648V14.9727C10.5605 15.5703 10.0566 15.9844 9.31836 15.9844C8.56836 15.9844 8.05664 15.6016 8.00195 15.0469L7.99805 15.0078H7.32227L7.32617 15.0547C7.40039 15.9453 8.1543 16.5938 9.31836 16.5938Z"
        fill={color}
      />
      <Path
        d="M14.3027 16.6328C15.5488 16.6328 16.2988 15.4961 16.2988 13.6836V13.6758C16.2988 11.8633 15.5488 10.7305 14.3027 10.7305C13.0566 10.7305 12.3145 11.8633 12.3145 13.6758V13.6836C12.3145 15.4961 13.0566 16.6328 14.3027 16.6328ZM14.3027 16.0195C13.4941 16.0195 13.0215 15.1211 13.0215 13.6836V13.6758C13.0215 12.2383 13.4941 11.3477 14.3027 11.3477C15.1113 11.3477 15.5918 12.2383 15.5918 13.6758V13.6836C15.5918 15.1211 15.1113 16.0195 14.3027 16.0195Z"
        fill={color}
      />
    </Icon>
  );
};

const InfoIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M13.7365 21.8481C15.0297 21.62 16.2654 21.1395 17.373 20.4339C18.4806 19.7283 19.4383 18.8115 20.1915 17.7358C20.9448 16.66 21.4787 15.4465 21.763 14.1644C22.0472 12.8823 22.0761 11.5568 21.8481 10.2635C21.62 8.97025 21.1395 7.73456 20.4339 6.627C19.7283 5.51945 18.8115 4.56171 17.7358 3.80848C16.66 3.05525 15.4465 2.52127 14.1644 2.23704C12.8823 1.95281 11.5568 1.92388 10.2635 2.15192C8.97025 2.37996 7.73456 2.86049 6.627 3.56609C5.51945 4.27168 4.56171 5.18851 3.80848 6.26424C3.05525 7.33996 2.52127 8.55352 2.23704 9.83561C1.95281 11.1177 1.92388 12.4432 2.15192 13.7365C2.37996 15.0298 2.86049 16.2654 3.56609 17.373C4.27168 18.4806 5.18851 19.4383 6.26424 20.1915C7.33996 20.9448 8.55352 21.4787 9.83561 21.763C11.1177 22.0472 12.4432 22.0761 13.7365 21.8481L13.7365 21.8481Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 11L12 17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 8L12 7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const MediaIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2383 15.1775L18.8311 13.7704L18.8086 13.7478L18.8086 13.7478C18.4138 13.353 18.0843 13.0235 17.7925 12.7776C17.488 12.521 17.1734 12.3099 16.7943 12.1955C16.2763 12.0392 15.7237 12.0392 15.2057 12.1955C14.8266 12.3099 14.5119 12.521 14.2075 12.7776C13.9157 13.0235 13.5862 13.353 13.1914 13.7478L13.1914 13.7478L13.1688 13.7704C12.8656 14.0737 12.6752 14.2629 12.5238 14.3881C12.4312 14.4646 12.3848 14.4896 12.3712 14.496C12.3169 14.5035 12.2615 14.4928 12.2138 14.4657C12.2036 14.4547 12.1698 14.4143 12.1122 14.3088C12.0182 14.1363 11.9117 13.89 11.7428 13.4957L11.6893 13.3711L11.672 13.3307L11.672 13.3307C11.3119 12.4905 11.0176 11.8037 10.7285 11.2899C10.4326 10.7642 10.0835 10.3081 9.55778 10.0445C9.10514 9.81764 8.59865 9.72009 8.09412 9.76267C7.5081 9.81212 7.01455 10.1059 6.54458 10.4842C6.08536 10.8538 5.55701 11.3822 4.91061 12.0286L4.87955 12.0597L3.75 13.1892C3.7501 13.9442 3.7512 14.6105 3.76218 15.2027C3.85998 15.1663 3.9517 15.1088 4.03032 15.0302L5.94021 13.1203C6.62528 12.4352 7.09661 11.9654 7.48509 11.6527C7.87015 11.3428 8.07743 11.2694 8.22025 11.2574C8.44958 11.238 8.67981 11.2823 8.88555 11.3855C9.01368 11.4497 9.17889 11.5948 9.4213 12.0256C9.66587 12.4602 9.92899 13.0715 10.3106 13.962L10.364 14.0866L10.3773 14.1175C10.5289 14.4714 10.6631 14.7845 10.7954 15.027C10.9327 15.2788 11.1173 15.5513 11.4163 15.7364C11.7814 15.9624 12.2169 16.0462 12.6398 15.972C12.9862 15.9112 13.2588 15.7267 13.4797 15.544C13.6926 15.368 13.9335 15.1271 14.2058 14.8548L14.2295 14.831C14.6527 14.4079 14.9371 14.1243 15.1741 13.9246C15.4039 13.7309 15.5368 13.6624 15.6389 13.6316C15.8744 13.5605 16.1256 13.5605 16.361 13.6316C16.4631 13.6624 16.596 13.7309 16.8258 13.9246C17.0628 14.1243 17.3473 14.4079 17.7705 14.831L19.4697 16.5302C19.6596 16.7202 19.9262 16.7869 20.1699 16.7305C20.2078 16.2752 20.2277 15.7622 20.2383 15.1775Z"
        fill={color}
      />
      <Circle cx="16.5" cy="7.5" r="1.5" fill={color} />
    </Icon>
  );
};

const DiamondIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 19.5L3.90027 11.6253C3.46257 11.1997 3.24372 10.987 3.17561 10.7072C3.10749 10.4275 3.20402 10.138 3.39706 9.55882L4.3383 6.73509C4.77832 5.41505 4.99832 4.75503 5.5221 4.37752C6.04587 4 6.74159 4 8.13304 4H15.867C17.2584 4 17.9541 4 18.4779 4.37752C19.0017 4.75503 19.2217 5.41505 19.6617 6.73509L20.6029 9.55882C20.796 10.138 20.8925 10.4275 20.8244 10.7072C20.7563 10.987 20.5374 11.1997 20.0997 11.6253L12 19.5ZM12 19.5L15.9375 9.625M12 19.5L8.0625 9.625M20.4375 10.75L15.9375 9.625M15.9375 9.625L14 4M15.9375 9.625H8.0625M10 4L8.0625 9.625M8.0625 9.625L3.5625 10.75"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const StarIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M10.0637 6.35434C10.8844 4.30822 11.2948 3.28516 12.0005 3.28516C12.7062 3.28516 13.1165 4.30822 13.9373 6.35434L13.9755 6.44962C14.4392 7.60558 14.671 8.18356 15.1435 8.53486C15.6161 8.88616 16.2363 8.94171 17.4768 9.05281L17.7011 9.0729C19.7314 9.25472 20.7465 9.34564 20.9637 9.99149C21.181 10.6373 20.4271 11.3232 18.9193 12.695L18.4161 13.1528C17.6528 13.8472 17.2712 14.1944 17.0933 14.6495C17.0601 14.7344 17.0326 14.8213 17.0107 14.9098C16.8938 15.3842 17.0056 15.8879 17.2291 16.8953L17.2987 17.2088C17.7094 19.0602 17.9148 19.9859 17.5562 20.3851C17.4222 20.5343 17.2481 20.6418 17.0546 20.6946C16.5368 20.8358 15.8018 20.2369 14.3317 19.0389C13.3663 18.2523 12.8837 17.859 12.3295 17.7705C12.1115 17.7357 11.8894 17.7357 11.6715 17.7705C11.1173 17.859 10.6346 18.2523 9.6693 19.0389C8.19919 20.2369 7.46413 20.8358 6.94639 20.6946C6.75293 20.6418 6.57877 20.5343 6.44477 20.3851C6.08618 19.9859 6.29156 19.0602 6.70232 17.2088L6.77189 16.8953C6.9954 15.8879 7.10715 15.3842 6.99023 14.9098C6.96842 14.8213 6.94084 14.7344 6.90766 14.6495C6.72978 14.1944 6.34815 13.8472 5.58489 13.1528L5.08168 12.695C3.57391 11.3232 2.82002 10.6373 3.03724 9.99149C3.25445 9.34564 4.26959 9.25472 6.29987 9.0729L6.52414 9.05281C7.76466 8.94171 8.38492 8.88616 8.85743 8.53486C9.32994 8.18356 9.56178 7.60558 10.0255 6.44962L10.0637 6.35434Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const HourglassIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M6.95265 5.98015C6.69615 6.94149 7.1253 9.46019 10.894 11.8443C8.29865 14.7283 6.27947 15.3532 6.95265 18.093M17.0473 5.98015C17.3038 6.94149 16.8746 9.46019 13.106 11.8443C15.7013 14.7283 17.7204 15.3532 17.0473 18.093M6.50074 5.61867H17.4992C18.2223 5.61867 18.8085 5.03246 18.8085 4.30934C18.8085 3.58621 18.2223 3 17.4992 3H6.50074C5.77762 3 5.19141 3.58621 5.19141 4.30934C5.19141 5.03246 5.77762 5.61867 6.50074 5.61867ZM6.50074 21H17.4992C18.2223 21 18.8085 20.4138 18.8085 19.6907C18.8085 18.9675 18.2223 18.3813 17.4992 18.3813H6.50074C5.77762 18.3813 5.19141 18.9675 5.19141 19.6907C5.19141 20.4138 5.77762 21 6.50074 21Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const DollarSignIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 2V22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.1667 6H9.91667C9.14312 6 8.40125 6.31607 7.85427 6.87868C7.30729 7.44129 7 8.20435 7 9C7 9.79565 7.30729 10.5587 7.85427 11.1213C8.40125 11.6839 9.14312 12 9.91667 12H14.0833C14.8569 12 15.5987 12.3161 16.1457 12.8787C16.6927 13.4413 17 14.2044 17 15C17 15.7956 16.6927 16.5587 16.1457 17.1213C15.5987 17.6839 14.8569 18 14.0833 18H7"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const UserIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M19.7274 20.4471C19.2716 19.1713 18.2672 18.0439 16.8701 17.2399C15.4729 16.4358 13.7611 16 12 16C10.2389 16 8.52706 16.4358 7.12991 17.2399C5.73276 18.0439 4.72839 19.1713 4.27259 20.4471"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Circle
        cx="12"
        cy="8"
        r="4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const ShieldIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9 11L11.1951 12.7073C11.4058 12.8712 11.708 12.8407 11.8817 12.638L15 9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M17.8 16.65L15 18.75C13.2222 20.0833 10.7778 20.0833 9 18.75L6.2 16.65C4.18555 15.1392 3 12.7681 3 10.25V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V10.25C21 12.7681 19.8144 15.1392 17.8 16.65Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const DatabaseIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Ellipse cx="12" cy="7" rx="7" ry="3" stroke={color} strokeWidth="1.5" />
      <Path
        d="M5 13C5 13 5 15.3431 5 17C5 18.6569 8.13401 20 12 20C15.866 20 19 18.6569 19 17C19 16.173 19 13 19 13"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <Path
        d="M5 7C5 7 5 10.3431 5 12C5 13.6569 8.13401 15 12 15C15.866 15 19 13.6569 19 12C19 11.173 19 7 19 7"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const CreditCardIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="3"
        y="6"
        width="18"
        height="13"
        rx="2"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M7 15H7.01"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 11L21 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const SmartphoneIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 18H12.01"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const SmsIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 81 80" {...props} color="transparent">
      <Path
        d="M57.168 68.3333H23.8346C13.8346 68.3333 7.16797 63.3333 7.16797 51.6666V28.3333C7.16797 16.6666 13.8346 11.6666 23.8346 11.6666H57.168C67.168 11.6666 73.8346 16.6666 73.8346 28.3333V51.6666C73.8346 63.3333 67.168 68.3333 57.168 68.3333Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M57.1654 30L46.732 38.3333C43.2987 41.0667 37.6653 41.0667 34.232 38.3333L23.832 30"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const GlobeIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2 12H22"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2V2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const PolicyIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M17.8 16.65L15 18.75C13.2222 20.0833 10.7778 20.0833 9 18.75L6.2 16.65C4.18555 15.1392 3 12.7681 3 10.25V5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V10.25C21 12.7681 19.8144 15.1392 17.8 16.65Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Circle cx="12" cy="10" r="1" fill={color} />
      <Circle cx="9" cy="10" r="1" fill={color} />
      <Circle cx="15" cy="10" r="1" fill={color} />
    </Icon>
  );
};

const FeedbackIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M3 12C3 7.02944 7.02944 3 12 3V3C16.9706 3 21 7.02944 21 12V17.7273C21 18.9161 21 19.5105 20.7554 19.9585C20.5716 20.295 20.295 20.5716 19.9585 20.7554C19.5105 21 18.9161 21 17.7273 21H12C7.02944 21 3 16.9706 3 12V12Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M9 11L15 11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 15H15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const LogOutIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M6.55556 7.5L3 12M3 12L6.55556 16.5M3 12H11"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10 8.51874V8.19865C10 6.57581 10 5.76439 10.4759 5.20433C10.9517 4.64426 11.7525 4.51323 13.354 4.25116L14.0311 4.14037C17.267 3.61085 18.885 3.34609 19.9425 4.24461C21 5.14313 21 6.78263 21 10.0616V13.9384C21 17.2174 21 18.8569 19.9425 19.7554C18.885 20.6539 17.267 20.3891 14.0311 19.8596L13.354 19.7488C11.7525 19.4868 10.9517 19.3557 10.4759 18.7957C10 18.2356 10 17.4242 10 15.8013V15.6594"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const DuoIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M14.9279 19.6828C14.6936 18.3633 13.9003 17.1608 12.696 16.2995C11.4916 15.4381 9.95822 14.9766 8.38152 15.0009C6.80483 15.0252 5.29236 15.5337 4.12589 16.4317C2.95942 17.3296 2.21852 18.5557 2.04121 19.8816"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M21.9279 19.6828C21.6936 18.3633 20.9004 17.1608 19.696 16.2995C18.4917 15.4381 16.9583 14.9766 15.3816 15.0009"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Circle
        cx="8.5"
        cy="7.5"
        r="3.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M15.5 11C17.433 11 19 9.433 19 7.5C19 5.567 17.433 4 15.5 4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const FamilyIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M17.439 19.6828C17.2407 18.3633 16.5695 17.1608 15.5504 16.2995C14.5313 15.4381 13.2339 14.9766 11.8998 15.0009C10.5656 15.0252 9.28584 15.5337 8.29883 16.4317C7.31182 17.3296 6.6849 18.5557 6.53487 19.8816"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Circle
        cx="11.9958"
        cy="8.5"
        r="3.5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M6.68804 10.8904C7.10185 10.872 7.42241 10.5217 7.40405 10.1079C7.38568 9.69409 7.03533 9.37352 6.62153 9.39189L6.68804 10.8904ZM3.00302 6.7998L2.25376 6.83306L3.00302 6.7998ZM6.34437 3.14804L6.37763 3.8973L6.34437 3.14804ZM8.29189 4.55889C8.60598 4.82893 9.07951 4.79322 9.34955 4.47913C9.61959 4.16505 9.58388 3.69152 9.26979 3.42148L8.29189 4.55889ZM6.62153 9.39189C5.10424 9.45924 3.81963 8.28383 3.75228 6.76654L2.25376 6.83306C2.35784 9.17796 4.34314 10.9945 6.68804 10.8904L6.62153 9.39189ZM3.75228 6.76654C3.68493 5.24926 4.86034 3.96465 6.37763 3.8973L6.31111 2.39878C3.96621 2.50286 2.14967 4.48816 2.25376 6.83306L3.75228 6.76654ZM6.37763 3.8973C7.1059 3.86497 7.77912 4.11803 8.29189 4.55889L9.26979 3.42148C8.47905 2.74163 7.43571 2.34886 6.31111 2.39878L6.37763 3.8973Z"
        fill={color}
      />
      <Path
        d="M17.3115 10.8904C16.8977 10.872 16.5771 10.5217 16.5955 10.1079C16.6138 9.69409 16.9642 9.37352 17.378 9.39189L17.3115 10.8904ZM20.9965 6.7998L21.7458 6.83306L20.9965 6.7998ZM17.6551 3.14804L17.6219 3.8973L17.6551 3.14804ZM15.7076 4.55889C15.3935 4.82893 14.92 4.79322 14.65 4.47913C14.3799 4.16505 14.4156 3.69152 14.7297 3.42148L15.7076 4.55889ZM17.378 9.39189C18.8953 9.45924 20.1799 8.28383 20.2472 6.76654L21.7458 6.83306C21.6417 9.17796 19.6564 10.9945 17.3115 10.8904L17.378 9.39189ZM20.2472 6.76654C20.3146 5.24926 19.1392 3.96465 17.6219 3.8973L17.6884 2.39878C20.0333 2.50286 21.8498 4.48816 21.7458 6.83306L20.2472 6.76654ZM17.6219 3.8973C16.8936 3.86497 16.2204 4.11803 15.7076 4.55889L14.7297 3.42148C15.5205 2.74163 16.5638 2.34886 17.6884 2.39878L17.6219 3.8973Z"
        fill={color}
      />
      <Path
        d="M21.9279 17.6828C21.6936 16.3633 20.9004 15.1608 19.696 14.2995C18.4917 13.4381 16.9583 12.9766 15.3816 13.0009"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2.00005 17.6828C2.23435 16.3633 3.02758 15.1608 4.23195 14.2995C5.43632 13.4381 6.9697 12.9766 8.54639 13.0009"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const CancelCircleIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 9L9 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9 9L15 15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const AllowCircleIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M9 12L11.1951 13.7073C11.4058 13.8712 11.708 13.8407 11.8817 13.638L15 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const SavedFolderIcon = ({
  color = "#FFFFFF",
  strokeWidth = "1.5",
  ...props
}: Props) => {
  return (
    <Icon
      viewBox="0 0 49 62"
      {...props}
      strokeWidth={strokeWidth}
      color="transparent"
    >
      <Path
        d="M47.8327 61L24.4993 44.3333L1.16602 61V7.66667C1.16602 5.89856 1.86839 4.20286 3.11864 2.95262C4.36888 1.70238 6.06457 1 7.83268 1H41.166C42.9341 1 44.6298 1.70238 45.8801 2.95262C47.1303 4.20286 47.8327 5.89856 47.8327 7.66667V61Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const TrashIcon = ({ color = "#FFFFFF", strokeWidth, ...props }: Props) => {
  return (
    <Icon
      viewBox="0 0 24 24"
      {...props}
      strokeWidth={strokeWidth}
      color="transparent"
    >
      <Path
        d="M19.325 9.46875C19.325 9.46875 18.782 16.2037 18.467 19.0407C18.317 20.3957 17.48 21.1898 16.109 21.2148C13.5 21.2618 10.888 21.2648 8.28003 21.2098C6.96103 21.1828 6.13803 20.3788 5.99103 19.0478C5.67403 16.1858 5.13403 9.46875 5.13403 9.46875"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M20.7082 6.24023H3.75024"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M17.4406 6.23998C16.6556 6.23998 15.9796 5.68498 15.8256 4.91598L15.5826 3.69998C15.4326 3.13898 14.9246 2.75098 14.3456 2.75098H10.1126C9.53358 2.75098 9.02558 3.13898 8.87558 3.69998L8.63258 4.91598C8.47858 5.68498 7.80258 6.23998 7.01758 6.23998"
        stroke={color}
        strokeWidth={strokeWidth || "1.5"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const EditIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M14.8907 5.58579L18.8907 9.58579M4.74398 15.3479L16.0919 4C16.7586 3.33333 17.0919 3 17.5061 3C17.9203 3 18.2537 3.33333 18.9203 4L20.4765 5.55619C21.1432 6.22285 21.4765 6.55619 21.4765 6.9704C21.4765 7.38462 21.1432 7.71795 20.4765 8.38462L9.12859 19.7325C8.93394 19.9272 8.83662 20.0245 8.71833 20.0915C8.60004 20.1585 8.46651 20.1918 8.19945 20.2586L3.69918 21.3837C3.33815 21.4739 3.15763 21.5191 3.05754 21.419C2.95745 21.3189 3.00258 21.1384 3.09284 20.7773L4.21791 16.2771C4.28467 16.01 4.31805 15.8765 4.38503 15.7582C4.452 15.6399 4.54933 15.5426 4.74398 15.3479Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const CategoryIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2856 2H19.5522C20.9037 2 22.0001 3.1059 22.0001 4.47018V7.7641C22.0001 9.12735 20.9037 10.2343 19.5522 10.2343H16.2856C14.933 10.2343 13.8367 9.12735 13.8367 7.7641V4.47018C13.8367 3.1059 14.933 2 16.2856 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.44892 2H7.71449C9.06703 2 10.1634 3.1059 10.1634 4.47018V7.7641C10.1634 9.12735 9.06703 10.2343 7.71449 10.2343H4.44892C3.09638 10.2343 2 9.12735 2 7.7641V4.47018C2 3.1059 3.09638 2 4.44892 2Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.44892 13.7656H7.71449C9.06703 13.7656 10.1634 14.8715 10.1634 16.2368V19.5297C10.1634 20.894 9.06703 21.9999 7.71449 21.9999H4.44892C3.09638 21.9999 2 20.894 2 19.5297V16.2368C2 14.8715 3.09638 13.7656 4.44892 13.7656Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2856 13.7656H19.5522C20.9037 13.7656 22.0001 14.8715 22.0001 16.2368V19.5297C22.0001 20.894 20.9037 21.9999 19.5522 21.9999H16.2856C14.933 21.9999 13.8367 20.894 13.8367 19.5297V16.2368C13.8367 14.8715 14.933 13.7656 16.2856 13.7656Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const TimerIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2498 12.001C21.2498 17.11 17.1088 21.251 11.9998 21.251C6.89076 21.251 2.74976 17.11 2.74976 12.001C2.74976 6.89198 6.89076 2.75098 11.9998 2.75098C17.1088 2.75098 21.2498 6.89198 21.2498 12.001Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.4314 14.9437L11.6614 12.6947V7.84766"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const CalendarIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M3.09253 9.40445H20.9165"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.0438 2V5.29078"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7.9654 2V5.29078"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2383 3.5791H7.77096C4.83427 3.5791 3 5.21504 3 8.22213V17.2718C3 20.3261 4.83427 21.9999 7.77096 21.9999H16.229C19.175 21.9999 21 20.3545 21 17.3474V8.22213C21.0092 5.21504 19.1842 3.5791 16.2383 3.5791Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const CameraIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6378 7.10975V7.10975C17.2648 7.10975 16.9268 6.89475 16.7678 6.55875C16.4808 5.95075 16.1158 5.17375 15.8998 4.75075C15.5808 4.12175 15.0638 3.75575 14.3478 3.75075C14.3358 3.74975 9.66376 3.74975 9.65176 3.75075C8.93576 3.75575 8.41976 4.12175 8.09976 4.75075C7.88476 5.17375 7.51976 5.95075 7.23276 6.55875C7.07376 6.89475 6.73476 7.10975 6.36276 7.10975V7.10975C4.36676 7.10975 2.74976 8.72675 2.74976 10.7217V16.6578C2.74976 18.6518 4.36676 20.2698 6.36276 20.2698H17.6378C19.6328 20.2698 21.2498 18.6518 21.2498 16.6578V10.7217C21.2498 8.72675 19.6328 7.10975 17.6378 7.10975Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.82139 13.3343C8.82039 15.0873 10.2514 16.5213 12.0014 16.5203C13.7484 16.5183 15.1754 15.0903 15.1784 13.3413C15.1814 11.5853 13.7554 10.1543 12.0034 10.1523C10.2414 10.1503 8.80739 11.6053 8.82139 13.3343Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16.9025 10.9951C16.8059 10.9852 16.7105 10.96 16.6036 10.9169C16.4847 10.8641 16.3818 10.7969 16.2823 10.6959C16.1035 10.5057 16 10.257 16 10.0005C16 9.86422 16.0279 9.72916 16.0823 9.60681C16.1368 9.48285 16.2014 9.37829 16.3182 9.26456C16.407 9.18719 16.498 9.12493 16.6224 9.07013C16.9913 8.92396 17.4301 9.0113 17.7043 9.28541C17.7865 9.36639 17.8557 9.46411 17.8941 9.54651L17.9169 9.60494C17.9721 9.72916 18 9.86422 18 10.0005C18 10.2622 17.8978 10.5043 17.7081 10.7058C17.5442 10.8708 17.3289 10.9723 17.0992 10.9951L17 11L16.9025 10.9951Z"
        fill={color}
      />
    </Icon>
  );
};

const DocumentIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M15.7161 16.2236H8.49609"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.7161 12.0371H8.49609"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M11.2511 7.86035H8.49609"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9085 2.75C15.9085 2.75 8.23149 2.754 8.21949 2.754C5.45949 2.771 3.75049 4.587 3.75049 7.357V16.553C3.75049 19.337 5.47249 21.16 8.25649 21.16C8.25649 21.16 15.9325 21.157 15.9455 21.157C18.7055 21.14 20.4155 19.323 20.4155 16.553V7.357C20.4155 4.573 18.6925 2.75 15.9085 2.75Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const UserCircleIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="12"
        cy="10"
        r="3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" />
      <Path
        d="M18 18.7059C17.6461 17.6427 16.8662 16.7033 15.7814 16.0332C14.6966 15.3632 13.3674 15 12 15C10.6326 15 9.30341 15.3632 8.21858 16.0332C7.13375 16.7033 6.35391 17.6427 6 18.7059"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const InfinityIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9.22184 10.4634C9.4914 10.7779 9.96488 10.8143 10.2794 10.5447C10.5939 10.2752 10.6303 9.80169 10.3607 9.4872L9.22184 10.4634ZM4.64534 7.9377L4.41105 7.22523L4.64534 7.9377ZM1.88243 13.2562L2.61003 13.0742L1.88243 13.2562ZM12.0015 12.0129L11.396 11.5704L12.0015 12.0129ZM14.1142 13.5701C13.8766 13.2308 13.409 13.1483 13.0697 13.3858C12.7303 13.6233 12.6478 14.091 12.8853 14.4303L14.1142 13.5701ZM9.80153 10.023L9.8949 10.7672C10.2709 10.72 10.5526 10.3998 10.5515 10.0208L9.80153 10.023ZM10.5413 6.49782C10.5401 6.08361 10.2033 5.7488 9.7891 5.75C9.37489 5.75121 9.04008 6.08797 9.04128 6.50218L10.5413 6.49782ZM5.90663 9.75584C5.49564 9.8074 5.20427 10.1824 5.25584 10.5934C5.3074 11.0044 5.68238 11.2957 6.09337 11.2442L5.90663 9.75584ZM10.3607 9.4872C9.82588 8.86322 9.02668 8.09264 8.02826 7.5764C7.01672 7.05337 5.76944 6.77854 4.41105 7.22523L4.87962 8.65016C5.76253 8.35983 6.58822 8.52046 7.33932 8.90883C8.10355 9.30397 8.75668 9.9207 9.22184 10.4634L10.3607 9.4872ZM4.41105 7.22523C1.85241 8.0666 0.458306 10.6524 1.15483 13.4381L2.61003 13.0742C2.09274 11.0054 3.11191 9.23145 4.87962 8.65016L4.41105 7.22523ZM1.15483 13.4381C1.31811 14.0911 1.75212 14.8424 2.37379 15.4772C3.00362 16.1204 3.87068 16.6898 4.93796 16.9106C7.14198 17.3665 9.80804 16.2864 12.6071 12.4553L11.396 11.5704C8.756 15.1837 6.61255 15.7252 5.2418 15.4417C4.52169 15.2927 3.91004 14.9021 3.44551 14.4278C2.97282 13.945 2.6968 13.4212 2.61003 13.0742L1.15483 13.4381ZM12.6071 12.4553C15.4236 8.6005 17.6405 8.18232 18.9688 8.63247C19.6783 8.87294 20.2739 9.393 20.6976 10.0417C21.1243 10.6949 21.3407 11.4245 21.3407 12.0129H22.8407C22.8407 11.0949 22.5171 10.0844 21.9535 9.22142C21.3869 8.35392 20.5418 7.58178 19.4502 7.21184C17.1762 6.44117 14.3485 7.52933 11.396 11.5704L12.6071 12.4553ZM21.3407 12.0129C21.3407 13.2595 20.301 14.7651 18.8162 15.3915C18.1014 15.693 17.3187 15.7724 16.5392 15.5326C15.7599 15.2928 14.9136 14.7121 14.1142 13.5701L12.8853 14.4303C13.8359 15.7883 14.9385 16.6095 16.0981 16.9663C17.2575 17.323 18.4038 17.1935 19.3993 16.7735C21.3349 15.9569 22.8407 13.9689 22.8407 12.0129H21.3407ZM10.5515 10.0208L10.5413 6.49782L9.04128 6.50218L9.05153 10.0252L10.5515 10.0208ZM9.70815 9.27885L5.90663 9.75584L6.09337 11.2442L9.8949 10.7672L9.70815 9.27885Z"
        fill={color}
      />
    </Icon>
  );
};

const SuccessIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" />
      <Path
        d="M8.43994 12L10.8139 14.373L15.5599 9.62695"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const GamesIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect x="13" y="14" width="2" height="2" rx="1" fill={color} />
      <Path
        d="M10 14H6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M8 12L8 16"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Rect x="16" y="12" width="2" height="2" rx="1" fill={color} />
      <Path
        d="M14 8V8C14 7.58326 14 7.37488 13.9655 7.19144C13.8455 6.5546 13.4245 6.01534 12.8358 5.74455C12.6662 5.66654 12.464 5.616 12.0597 5.51493L12 5.5C11.5388 5.3847 11.3082 5.32706 11.1171 5.233C10.5686 4.96315 10.1737 4.45731 10.0449 3.85979C10 3.65151 10 3.41382 10 2.93845V2"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 14C3 11.4412 3 10.1618 3.61994 9.28042C3.77954 9.05351 3.96572 8.85041 4.17372 8.6763C4.98164 8 6.15442 8 8.5 8H15.5C17.8456 8 19.0184 8 19.8263 8.6763C20.0343 8.85041 20.2205 9.05351 20.3801 9.28042C21 10.1618 21 11.4412 21 14C21 16.5588 21 17.8382 20.3801 18.7196C20.2205 18.9465 20.0343 19.1496 19.8263 19.3237C19.0184 20 17.8456 20 15.5 20H8.5C6.15442 20 4.98164 20 4.17372 19.3237C3.96572 19.1496 3.77954 18.9465 3.61994 18.7196C3 17.8382 3 16.5588 3 14Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  );
};

const LockIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M19 10H5C3.89543 10 3 10.8954 3 12V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V12C21 10.8954 20.1046 10 19 10Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M7 10V6.89063C6.99876 5.92676 7.45631 4.99692 8.28382 4.28161C9.11132 3.5663 10.2498 3.11655 11.4781 3.01969C12.7065 2.92282 13.9371 3.18574 14.9311 3.7574C15.9251 4.32907 16.6116 5.1687 16.8573 6.11329C17.103 7.05788 16.9569 10 16.9569 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 13V17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};

const ReduceSizeIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M15 20V15M15 15H20M15 15L21 21M15 4V9M15 9H20M15 9L21 3M9 20V15M9 15H4M9 15L3 21M9 4V9M9 9H4M9 9L3 3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const ScaleSizeIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M21.75 15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15H21.75ZM21 21V21.75C21.4142 21.75 21.75 21.4142 21.75 21H21ZM15 20.25C14.5858 20.25 14.25 20.5858 14.25 21C14.25 21.4142 14.5858 21.75 15 21.75V20.25ZM16.5303 15.4697C16.2374 15.1768 15.7626 15.1768 15.4697 15.4697C15.1768 15.7626 15.1768 16.2374 15.4697 16.5303L16.5303 15.4697ZM3.75 15C3.75 14.5858 3.41421 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15H3.75ZM3 21H2.25C2.25 21.4142 2.58579 21.75 3 21.75V21ZM9 21.75C9.41421 21.75 9.75 21.4142 9.75 21C9.75 20.5858 9.41421 20.25 9 20.25V21.75ZM8.53033 16.5303C8.82322 16.2374 8.82322 15.7626 8.53033 15.4697C8.23744 15.1768 7.76256 15.1768 7.46967 15.4697L8.53033 16.5303ZM20.25 9C20.25 9.41421 20.5858 9.75 21 9.75C21.4142 9.75 21.75 9.41421 21.75 9H20.25ZM21 3H21.75C21.75 2.58579 21.4142 2.25 21 2.25V3ZM15 2.25C14.5858 2.25 14.25 2.58579 14.25 3C14.25 3.41421 14.5858 3.75 15 3.75V2.25ZM15.4697 7.46967C15.1768 7.76256 15.1768 8.23744 15.4697 8.53033C15.7626 8.82322 16.2374 8.82322 16.5303 8.53033L15.4697 7.46967ZM2.25 9C2.25 9.41421 2.58579 9.75 3 9.75C3.41421 9.75 3.75 9.41421 3.75 9H2.25ZM3 3V2.25C2.58579 2.25 2.25 2.58579 2.25 3H3ZM9 3.75C9.41421 3.75 9.75 3.41421 9.75 3C9.75 2.58579 9.41421 2.25 9 2.25V3.75ZM7.46967 8.53033C7.76256 8.82322 8.23744 8.82322 8.53033 8.53033C8.82322 8.23744 8.82322 7.76256 8.53033 7.46967L7.46967 8.53033ZM20.25 15V21H21.75V15H20.25ZM21 20.25H15V21.75H21V20.25ZM21.5303 20.4697L16.5303 15.4697L15.4697 16.5303L20.4697 21.5303L21.5303 20.4697ZM2.25 15V21H3.75V15H2.25ZM3 21.75H9V20.25H3V21.75ZM3.53033 21.5303L8.53033 16.5303L7.46967 15.4697L2.46967 20.4697L3.53033 21.5303ZM21.75 9V3H20.25V9H21.75ZM21 2.25H15V3.75H21V2.25ZM20.4697 2.46967L15.4697 7.46967L16.5303 8.53033L21.5303 3.53033L20.4697 2.46967ZM3.75 9V3H2.25V9H3.75ZM3 3.75H9V2.25H3V3.75ZM2.46967 3.53033L7.46967 8.53033L8.53033 7.46967L3.53033 2.46967L2.46967 3.53033Z"
        fill={color}
      />
    </Icon>
  );
};

const SwitchIcon = ({ color = "#FFFFFF", ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9 14L5 10L1 14"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15.875 18.7117C14.6255 19.4331 13.1993 19.7914 11.7572 19.7462C10.315 19.701 8.91415 19.2541 7.71224 18.4558C6.51033 17.6575 5.55513 16.5396 4.95419 15.2279C4.35324 13.9161 4.13042 12.4626 4.3108 11.0311"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M15 10L19 14L23 10"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.125 5.2883C9.39268 4.55641 10.8417 4.19849 12.3044 4.25598C13.767 4.31347 15.1835 4.78402 16.3898 5.61315C17.5962 6.44229 18.543 7.59611 19.1208 8.94106C19.6985 10.286 19.8836 11.7671 19.6545 13.2128"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export {
  ArrowDownIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  ArrowLeftIcon,
  NotificationIcon,
  MusicTwoIcon,
  MicroIcon,
  VideoIcon,
  FolderIcon,
  FolderAddIcon,
  FolderRemoveIcon,
  SearchIcon,
  MusicIcon,
  CopyIcon,
  EyeClosedIcon,
  EyeOpenedIcon,
  MoreVerticalIcon,
  AirPlayIcon,
  ShareIcon,
  DownloadIcon,
  DownloadedIcon,
  CheckIcon,
  ShuffleIcon,
  SortIcon,
  RepeatIcon,
  RepeatOneTimeIcon,
  LyricsIcon,
  ArtistMusicIcon,
  ArtistVideoIcon,
  ArtistDontRecommendIcon,
  ArtistAllowedRecommendIcon,
  PlaylistIcon,
  PlaylistOldIcon,
  AddToPlaylistIcon,
  DontRecommendIcon,
  AllowedRecommendIcon,
  AlbumIcon,
  ShowVideoIcon,
  PlaylistVideoIcon,
  PlaylistVideoAddedIcon,
  ShowPodcastIcon,
  PlayLineIcon,
  FavoriteLightIcon,
  WifiOffIcon,
  TileIcon,
  ListIcon,
  MoveIcon,
  BurgerMenuIcon,
  PlayNextIcon,
  PlayLastIcon,
  UnsubscribeIcon,
  EmailIcon,
  PinIcon,
  GenderIcon,
  CastIcon,
  CloseIcon,
  QuestionIcon,
  ReportIcon,
  SettingIcon,
  ResetIcon,
  FilterIcon,
  FullScreenIcon,
  SmallScreenIcon,
  FullScreenTwoIcon,
  ScaleUpIcon,
  DoubleCheckIcon,
  TimeIcon,
  AddIcon,
  Next30Icon,
  Previews30Icon,
  InfoIcon,
  MediaIcon,
  DiamondIcon,
  StarIcon,
  HourglassIcon,
  DollarSignIcon,
  UserIcon,
  ShieldIcon,
  DatabaseIcon,
  CreditCardIcon,
  SmartphoneIcon,
  GlobeIcon,
  PolicyIcon,
  FeedbackIcon,
  LogOutIcon,
  DuoIcon,
  FamilyIcon,
  CancelCircleIcon,
  AllowCircleIcon,
  TrashIcon,
  EditIcon,
  CategoryIcon,
  TimerIcon,
  CalendarIcon,
  CameraIcon,
  DocumentIcon,
  UserCircleIcon,
  InfinityIcon,
  SuccessIcon,
  GamesIcon,
  LockIcon,
  ReduceSizeIcon,
  ScaleSizeIcon,
  SwitchIcon,
  CloseSquareIcon,
  SmsIcon,
  SavedFolderIcon,
};
